/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect, useRef} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {
  approveSO,
  getDetailSO,
  printSO,
  rejectSO,
  getPaymentSO,
  getAccesses,
  editSOItem,
  soItemEdit,
  syncSO,
  updateAdditionalText,
  getSODetailContract,
  resubmitSO,
} from '../../../api/modules/so'
import {
  getProvince2,
  getProvince3,
  getPlant,
  getIncoterm,
  getTOPAnper,
  getTOPCust,
  getFindocDataTable,
  getFindocDataTableSearch,
  getSloc,
  getSalesOfficeList,
  getEndUser,
  getPayment,
  getAllPaymentList,
  getProductType,
  getProductName,
  getRoute,
} from '../../../api/modules/getdatalist'
import {getAllTransport, getPPN, getDetailFileConfig} from '../../../api/modules/master-data/master'
import {
  getCusGrup,
  getAccAssSO,
  getFilterCity,
  getRoleFlagList,
  getConfigLetter,
  getBatasTanggalLetter,
} from '../../../api/modules/master-data/master_2'
import swal from 'sweetalert'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Country from '../component/DataCountry.json'
import CustomUseEffect from '../content/offer/CustomUseEffect'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import axios from 'axios'
import {getPlant2} from '../../../api/modules/getdatalist'
import Pagination from '../component/Pagination'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import Select from 'react-select'
import AddRemoveJadwal from '../si/AddRemoveJadwal'
import CurrencyInput from 'react-currency-input-field'
import {getCustomer} from '../../../api/modules/findoc'
import InputGroup from 'react-bootstrap/InputGroup'
import {te} from 'date-fns/locale'
import {MultiSelect} from 'react-multi-select-component'
import {PopoverText} from '../../../components/Popover/Popover'
import DatePicker from 'react-datepicker'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {authSelector} from 'src/redux/slices/authSlices'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {ActionIcon, RichText, SkeletonPageDetail} from 'src/components'
import {ModalEditSO} from 'src/components/ModalEditSO/ModalEditSO'
import {
  putOrderItem,
  setDetailSOContract,
  setOrderItem,
  setOrderItems,
  soSelector,
} from 'src/redux/slices/soSlices'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import * as TableUI from '../../../components/Table/Table'
import { getForModule } from 'src/api/modules/configuration/signing'
import { log } from 'console'
import ModalAddSO from './revisi/ModalAddSO'
import { Notes } from '../si/FormDetailSIP/RowItem'
import ReactSelect from 'react-select'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment, handleDownloadBase64 } from 'src/app/helpers/file'

const SOReviseNew: React.FC = () => {
  const intl = useIntl()
  const dispath = useDispatch()
  const appDispatch = useAppDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const {orderItem, orderItems} = useAppSelector(soSelector)
  const {roleId} = useAppSelector(authSelector)
  const hakAkses = HakAkses()
  const [btnLoading, setBtnLoading] = useState(false)

  const [show, setShow] = useState(false)
  const [show3, setShow3] = useState(false)
  const [approveState, setApproveState] = useState(false)
  const [pickupDate, setPickupDate] = useState<any>(null)

  const [showEdit, setShowEdit] = useState(false)

  const handleCloseEdit = () => setShowEdit(false)
  const handleShowEdit = () => setShowEdit(true)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [prinout, setPrintout] = useState('')
  const [printoutState, setPrinoutState] = useState(true)
  // const [userState, setUserState] = useState("Anper");
  const [userState, setUserState] = useState('Customer')

  const [showApprove, setShowApprove] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [showModalEditSO, setShowModalEditSO] = useState(false)

  //#region
  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [SODetail, setSODetail] = useState<any[]>([])
  const [kontrakID, setKontrakID] = useState('')
  const [trans, setTrans] = useState('')
  const [transType, setTransType] = useState('')
  const [transType2, setTransType2] = useState('')
  const [hydro, setHydro] = useState('')
  const [stowage, setStowage] = useState('')
  const [pot, setPot] = useState('')
  const [country, setCountry] = useState('')
  const [province, setProvince] = useState('')
  const [pay, setPay] = useState('')
  const [paySAP, setPaySAP] = useState('')
  const [booking, setBooking] = useState('')
  const [soID, setSOID] = useState('')
  const [rejectNote, setRejectNote] = useState({reason: ''})
  const [assinger, setAssigner] = useState('')
  const [position, setPosition] = useState('')
  const [arrayEnduser, setEnduserArray] = useState([])
  const [showLetter, setShowLetter] = useState(false)
  const [custGroup, setCustGroup] = useState('')
  const [assinger2, setAssigner2] = useState('')
  const [position2, setPosition2] = useState('')
  const [ship, setShip] = useState('')
  const [SIP_ID, setSIP_ID] = useState(0)
  const [files, setFiles] = useState({file: null})
  const [files2, setFiles2] = useState({file: null})
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [trans2, setTrans2] = useState('')
  const [hydro2, setHydro2] = useState('')
  const [stowage2, setStowage2] = useState('')
  const [pot2, setPot2] = useState('')
  const [country2, setCountry2] = useState('')
  const [province2, setProvince2] = useState('')
  const [pay2, setPay2] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const [kontrak, setKontrak] = useState({
    sip_order: {id: 0},
  })
  const [SIPOrder, setSIPOrder] = useState(0)
  const [fullPayment, setFullPayment] = useState<any>([])
  const [isApprove, setIsApprove] = useState(false)
  const [approvalFlag, setApprovalFlag] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullIncoterm, setFullIncoterm] = useState<any>([])

  const [custCode, setCustCode] = useState('')
  const [salesorg, setSalesorg] = useState('')
  const [findocLoc, setFindocLoc] = useState('')
  const [priceBefore, setPriceBefore] = useState<any>(0)
  const [priceAfter, setPriceAfter] = useState<any>(0)
  const [showBrowseFindoc, setShowBrowseFindoc] = useState(false)
  const [selectedFindoc, setSelectedFindoc] = useState('')

  const [editId, setEditId] = useState('')
  const [editMaterialProd, setEditMaterialProd] = useState('')
  const [editDisChannel, setEditDisChannel] = useState('')

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [customerPreview, setCustomerPreview] = useState('')
  const [fullTransport, setFullTransport] = useState<any>([])
  const [ppn, setppn] = useState(0)
  const [totalquant, setTotalquant] = useState<any>(0)
  // const [payloadPlant, setPayloadPlant] = useState<any[]>([])
  // const [payloadPlant2, setPayloadPlant2] = useState<any[]>([])
  // const [payloadSloc, setPayloadSloc] = useState<any[]>([])
  // const [payloadSloc2, setPayloadSloc2] = useState<any[]>([])
  const [plantName, setPlantName] = useState('')
  const [plantID, setPlantID] = useState('')
  const [tempQuant, setTempQuant] = useState<any>(0)
  const [tempIndex, setTempIndex] = useState(0)
  const [fullSloc, setFullSloc] = useState<any>([])
  const [sloc, setSloc] = useState('')
  const [slocDesc, setSlocDesc] = useState('')
  const [status, setStatus] = useState(0)
  const [idSector, setIDSector] = useState(0)
  const [currency, setCurrency] = useState('')
  const [statusText, setStatusText] = useState('')
  const [incotermIdDesc, setIncotermIdDesc] = useState<any>()
  const [isApprovalAnper, setIsApprovalAnper] = useState(false)
  const [TOPDesc, setTOPDesc] = useState('')
  const [TOPDesc2, setTOPDesc2] = useState('')
  const [editFlag, setEditFlag] = useState(false)
  const [fullCity, setFullCity] = useState<any>([])
  const [fullCity2, setFullCity2] = useState<any>([])
  const [dist, setDist] = useState('')
  const [city, setCity] = useState('')
  const [city2, setCity2] = useState('')
  const [custGroup2, setCustGroup2] = useState('')
  const [custAssign2, setCustAssing2] = useState('')
  const [regarding, setRegarding] = useState('')
  const [orderSubID, setOrderSubID] = useState(0)
  const [showJadwal, setShowJadwal] = useState(false)
  const [kontrakIncoterm, setKontrakIncoterm] = useState<any>(0)
  const [provinsiTujuan, setProvinsiTujuan] = useState<any>('')
  const [provinsiTujuan2, setProvinsiTujuan2] = useState<any>('')
  const [provinsiTujuanSource, setProvinsiTujuanSource] = useState<any>('')
  const [provinsiTujuan2Source, setProvinsiTujuan2Source] = useState<any>('')
  const [fullRoute, setFullRoute] = useState<any>([])
  const [routeDesc, setRouteDesc] = useState('')
  const [notes, setNotes] = useState('')
  const [route, setRoute] = useState('')

  const [enduser, setEnduser] = useState('')
  const [provinceProduct, setProvinceProduct] = useState(0)
  const [warehouse, setWarehouse] = useState('')
  const [ptype, setPtype] = useState('')
  const [punit, setPunit] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [pspecProduct, setPspecProduct] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2Product, setPay2Product] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [provinceDesc, setProvinceDesc] = useState('')
  const [cityProduct, setCityProduct] = useState<any>('')
  const [cityDesc, setCityDesc] = useState('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [keterangan, setketerangan] = useState('')
  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [segment, setSegment] = useState<any>('')
  const [segmentDesc, setSegmentDesc] = useState<any>('')
  const [fullProductName, setFullProductName] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [showAddProduct, setShowAddProduct] = useState(false)
  const [addedProduct, setAddedProduct] = useState<any[]>([])
  const [tempDetail, setTempDetail] = useState<any>([])
  const [showDetail, setShowDetail] = useState(false)
  const [quantumSO, setQuantumSO] = useState(0)
  const [rute, setRute] = useState('')
  const [totalPriceProductBefore, setTotalPriceProductBefore] = useState<any>(0)
  const [totalPriceProductAfter, setTotalPriceProductAfter] = useState<any>(0)
  const [totalQuantumProduct, setTotalQuantumProduct] = useState<any>(0)
  const [salesorgname, setSalesOrgName] = useState('')
  const [fullProductType, setFullProductType] = useState<any[]>([])
  const [showEdit2, setShowEdit2] = useState(false)
  // const [shipto, setShipTo] = useState(false)
  const [customer, setCustomer] = useState('')
  const [numberURL2, setNumberURL2] = useState([])
  const [showCustomer, setShowCustomer] = useState(false)
  const [custName, setCustName] = useState('')
  const [custNum, setCustNum] = useState('')
  const [customerID, setCustomerID] = useState<any>('')
  const [fullCustomer, setFullCustomer] = useState<any[]>([])
  const [shipping, setShipping] = useState<any>(0)
  const [shipCust, setShipCust] = useState<any>('')
  const [leftoverArray, setLeftoverArray] = useState<any>([])
  const [leftoverIndex, setLeftoverIndex] = useState<any>(0)
  const [totalbatas, setTotalBatas] = useState<any>(0)
  const [totalbatasnonst, setTotalBatasNonST] = useState<any>(0)
  const [sisa, setSisa] = useState<any>(0)
  const [sisanost, setSisaNoST] = useState<any>(0)
  const [taking, setTaking] = useState(0)
  const [plantNameEn, setPlantNameEn] = useState('')
  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [listYear, setListYear] = useState<any[]>([])
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [editedIndex, setEditedIndex] = useState<any>()
  const [tempData, setTempData] = useState({
    id: null,
    order_sub_item_id: null,
    schedules: [],
    attachments: [],
  })
  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [dateNow, setDateNow] = useState('')
  const [showJadwal2, setShowJadwal2] = useState(false)
  const [index2, setIndex2] = useState(0)
  const [showUpload3, setShowUpload3] = useState(false)
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])
  const [files3, setFiles3] = useState<any>()
  const [filesHydro, setFilesHydro] = useState<any>()
  const [filesHydroName, setFilesHydroName] = useState<any>()
  const [filesShip, setFilesShip] = useState<any>()
  const [filesShipName, setFilesShipName] = useState<any>()
  const [uploadType, setUploadType] = useState('')
  const [totalPcs, setTotalPcs] = useState(0)
  const [totalPcsProduct, setTotalPcsProduct] = useState(0)
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')
  const [SONumber, setSONumber] = useState<any>('')
  const [shipping_tolerance, setShippingTolerance] = useState(0)

  const [incoterm, setIncoterm] = useState<any>(null)
  const [incoterm2, setIncoterm2] = useState<any>(null)

  const [pph22, setPPH22] = useState<any>(0)
  const [fileBox, setFileBox] = useState<any>({})
  const [signingPayload, setSigningPaylod] = useState({
    module: 'SO',
    sector_id: '',
    total_quantum: 0,
    province_id: '',
    city_id: '',
    sales_org_code: '',
    product_type: ''
  })
  //#endregion

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    setEditedIndex(null)
  }

  const clearInputJadwal = () => {
    const input1 = document.getElementById('jadwalminggu') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    input5.selectedIndex = 0
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const checktaking = () => {
    let temp: any[] = tempData?.schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const sendJadwal = () => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()
    const tempOrder: any[] = [...addedProduct]
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (tempOrder[index2]?.request_quantum >= tempoquantum + tempTon) {
          let temp: any[] = tempData?.schedules
          let sort = tempData?.schedules?.length
          const tempobject = {
            sort: sort + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp.push(tempobject)
          }
          const temptaking = taking + 1
          setTaking(temptaking)
          tempOrder[index2].schedules = temp
          setAllJadwal(temp)
          setAddedProduct(tempOrder)
          clearInputJadwal()
          clearStateJadwal()
          // setShowJadwal(false)
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const hapusSchedule = (index: any) => {
    const tempOrder: any[] = [...addedProduct]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let temp: any[] = tempData?.schedules
        temp.splice(index, 1)
        tempOrder[index2].schedules = temp
        setEditedIndex(null)
        const temptaking = taking - 1
        setTaking(temptaking)
        setAllJadwal(temp)
        setAddedProduct(tempOrder)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    const tempOrder: any[] = [...addedProduct]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (tempOrder[index2]?.request_quantum >= tempoquantum - tonlama + tempTon) {
            let temp: any[] = tempData?.schedules
            temp[index].tonnage = tonnage
            tempOrder[index2].schedules = temp
            setEditedIndex(null)
            setAllJadwal(temp)
            setAddedProduct(tempOrder)
            swal({
              title: `${t('jadwalBerhasilDiEdit')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const validasiFile = () => {
    if (files3 == null || files3 == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const getBase64 = (file: any) => {
    // console.log(file.name)
    setNamaFile(file.name)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      setFiles3(reader.result)
    }
    reader.onerror = function (error) {
      alert('Error: ' + error)
    }
  }

  const getBase64Doc = (file: any, type: string) => {
    // console.log(file.name)
    setNamaFile(file.name)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      if (type == 'hydro') {
        setFilesHydro(reader.result)
      } else {
        setFilesShip(reader.result)
      }
    }
    reader.onerror = function (error) {
      alert('Error: ' + error)
    }
  }

  const handleUpload3 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {

      let temparray: any[] = []

      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }

      let tempObject = {
        file_r: files3,
        name: namaFile,
        description: description,
        file_type: dataType,
        roles: temparray,
        private: isPrivate,
      }

      let temp: any = tempData?.attachments
      
      if (temp == null) {
        const temp2 = []
        temp2.push(tempObject)
        temp = temp2
      } else {
        temp.push(tempObject)
      }

      tempData?.id ? setSODetail(SODetail.map((itm, _idx) => {
        return _idx == index2 ? { ... itm, attachments: temp} : itm
      })) : setAddedProduct(addedProduct.map((itm, _idx) => {
        return _idx == index2 ? { ... itm, attachments: temp} : itm
      }))

      setTempData({...tempData, attachments: temp})

      setOrderItemsFiles(temp)

      clearInputUpload()
      removeFileState()

      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })

    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const handleUploadOrderItem = (item: any) => {
    setTempData(item)
    setOrderItemsFiles(item?.attachments || [])
    setUploadType('order-item')
    setShowUpload3(true)
  }

  const handleDeleteUploadHeader = (
    index: any,
    data: any,
    setData: any,
    type: any,
    datafull: any,
    setdatafull: any
  ) => {
    if (type == 'header') {
      // const tempArray = [...data]
      // console.log(tempArray)
      // tempArray.splice(index, 1)
      // setData(tempArray)
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            tempArray.splice(index, 1)
            setData(tempArray)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    } else {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            const tempfull = datafull
            tempArray?.splice(index, 1)
            tempfull.attachments = tempArray
            setData(tempArray)
            setSODetail(SODetail.map((item:any, idx: number) => {
              return index2 == idx ? tempfull : item
            }))
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Deletes')}`,
            icon: 'error',
          })
        })
    }
  }

  const handleJadwal = (item: any) => {
    setTempData(item)
    setAllJadwal(item?.schedules)

    if (item?.schedules?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(item?.schedules?.length)
    }

    setShowJadwal2(true)
  }

  const handleCustomer = async () => {
    setCustName('')
    setCustNum('')
    await getCustomer(salesorg, dist, '', '').then((res: any) => {
      setFullCustomer(res.data.data.data)
      setNumberURL2(res.data.data.links)
      setShowCustomer(true)
    })
  }

  const paginateNumber2 = async (number: any) => {
    const res = await axios.get(
      `${number}&sales_org_code=&customer_code=${custNum}&name=${custName}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullCustomer(res.data.data.data)
    setNumberURL2(res.data.data.links)
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomer(salesorg, dist, custName, custNum).then((res: any) => {
        setFullCustomer(res.data.data.data)
        setNumberURL2(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [custName, custNum])

  const [disableCKBOX, setDisableCKBOX] = useState(false)
  const separateValue4 = (value: any, state: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    if (temp[0] != 0) setDisableCKBOX(true)
    else setDisableCKBOX(false)
  }

  const checkMandatory = () => {
    // if ((enduser == '' || enduser == '0') && ptype != '8105') return t('isi') + t('End User')
    if (
      ((idSector == 1 &&
        ((arrayEnduser.length < 1 && isNoEnduser == false) ||
          (isNoEnduser == true && enduser == ''))) ||
        (idSector == 3 && enduser == '')) &&
      ptype != '8105'
    )
      return t('isi') + t('End Customer')
    else if (provinceProduct == 0) return t('isi') + t('Province')
    else if (idSector != 3 && cityProduct == 0) return t('isi') + t('City')
    else if (pnumber == '') return t('isi') + t('Product Name')
    else if ((subprice == 0 || subprice == undefined) && ptype != '8105')
      return t('isi') + t('Submission Price')
    else if (quantum == 0 || quantum == '') return t('isi') + t('Quantum')
    else if (pay1 == '') return t('isi') + t('Payment 1')
    else if (idSector == 1 && segment == '') return t('isi') + t('segment')
    else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
    else if (shipping >= 100) return t('Shipping tolerance melebihi 100%')
    else return 'nothing'
  }

  const insertAddOrder = () => {
    const mandatoryCheck = checkMandatory()
    // console.log(mandatoryCheck)
    if (mandatoryCheck == 'nothing') {
      let enduser1: any = []
      let enduser2: any = []
      if (!isNoEnduser) {
        arrayEnduser.forEach((data: any) => {
          enduser1.push(data.value)
          enduser2.push(data.label)
        })
      } else {
        enduser1 = enduserDesc
        enduser2 = enduserDesc
      }
      let tempprice = 0
      if (subprice == '' || isNaN(parseFloat(subprice))) tempprice = 0
      else tempprice = parseFloat(subprice)

      let inc1 = fullIncoterm.find((item: any) => {
        let expl = item.value?.split("~#~")
        return expl[0] == incoterm
      })
      const tempOrder = addedProduct
      const temp = {
        sales_org_code: salesorg,
        produsen: {name: salesorgname},
        sales_org_code_desc: salesorgname,
        incoterm1: inc1 ? {id: incoterm, code: inc1?.label} : null,
        incoterm1_id: incoterm,
        incoterm1_desc: inc1?.label,
        incoterm2_id: incoterm2,
        incoterm2: incoterm2,
        product_type: ptype,
        product_type_desc: ptype2,
        product_name: pname,
        product_spec: pspecProduct,
        fixed_price: tempprice,
        request_price: tempprice,
        request_quantum: parseFloat(quantum),
        fixed_quantum: parseFloat(quantum),
        shipping_tolerance: shipping,
        province_id: provinceProduct,
        province: {region_name: provinceDesc},
        province_desc: provinceDesc,
        city_id: cityProduct,
        city: {city_name: cityDesc},
        payment_note: keterangan,
        city_desc: cityDesc,
        sector_id: idSector,
        end_user: idSector != 1 ? enduserDesc : enduser1.toString(),
        notes: note,
        material_number: pnumber,
        unit: punit,
        segment_code: segment,
        segment_name: segmentDesc,
        plant: '',
        plant_desc: '',
        sloc: '',
        sloc_description: '',
        quantity: parseFloat(quantum),
        route: '',
        route_desc: '',
        schedules: [],
        attachments: [],
        end_user_multiple: idSector != 1 ? false : !isNoEnduser,
        payment_type_2_desc: pay1Desc,
        payment_type_1_desc: pay2Desc,
        newProduct: true,
        plant_desc_en: plantNameEn,
      }
      tempOrder.push(temp)
      let tempTotal = tempOrder.reduce(
        (a: any, b: any, index: any) => a + (b.quantity * b.request_price || 0),
        0
      )
      // let temptotalppn = tempOrder.reduce(
      //   (a: any, b: any, index: any) =>
      //     a +
      //     ((ppn / 100) * (b.quantity * b.request_price) +
      //     b.quantity * b.request_price || 0),
      //   0
      // )
      let temptotalppn = tempOrder.reduce(
        (a: any, b: any, index: any) =>
          a +
          (Math.round(b.quantity * (b.request_price + Math.round((b.request_price / 100) * ppn))) ||
            0),
        0
      )
      let totalquantum = tempOrder.reduce(
        (a: any, b: any, index: any) => (b.product_type != '8105' ? a + (b.quantity || 0) : a + 0),
        0
      )
      let totalpcs = tempOrder.reduce(
        (a: any, b: any, index: any) => (b.product_type == '8105' ? a + (b.quantity || 0) : a + 0),
        0
      )

      setTotalQuantumProduct(totalquantum)
      setTotalPcsProduct(totalpcs)
      setTotalPriceProductBefore(tempTotal)
      setTotalPriceProductAfter(temptotalppn)
      setAddedProduct(tempOrder)

      const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalquant
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

      setShowAddProduct(false)
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const removeProduct = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temparray: any = [...addedProduct]

        temparray.splice(index, 1)
        let totalPrice = temparray.reduce(
          (a: any, b: any, index: any) => a + (b.quantity * b.request_price || 0),
          0
        )
        // let totalPricePpn = temparray.reduce(
        //   (a: any, b: any, index: any) =>
        //     a +
        //     ((ppn / 100) * (b.quantity * b.request_price) + (b.quantity * b.request_price) || 0),
        //   0
        // )
        let totalPricePpn = temparray.reduce(
          (a: any, b: any, index: any) =>
            a +
            (Math.round(
              b.quantity * (b.request_price + Math.round((b.request_price / 100) * ppn))
            ) || 0),
          0
        )
        let totalquantum = temparray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type != '8105' ? a + (b.quantity || 0) : a + 0,
          0
        )
        let totalpcs = temparray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type == '8105' ? a + (b.quantity || 0) : a + 0,
          0
        )
        setTotalPcsProduct(totalpcs)
        setTotalQuantumProduct(totalquantum)
        setTotalPriceProductBefore(totalPrice)
        setTotalPriceProductAfter(totalPricePpn)
        setAddedProduct(temparray)

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalquant
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        swal({
          title: `${t('Item SO deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const editSelectedDetailProduct = () => {
    const temparray: any[] = addedProduct
    let inc1 = fullIncoterm.find((item: any) => {
      let excl = item.value?.split("~#~")
      return excl[0] == incoterm
    })
    temparray[tempIndex].incoterm1_id = incoterm
    temparray[tempIndex].incoterm1_desc = inc1?.label
    temparray[tempIndex].incoterm2_id = incoterm2
    temparray[tempIndex].incoterm2 = incoterm2
    temparray[tempIndex].incoterm1 = inc1 ? {
      id: incoterm,
      code: inc1?.label
    } : null
    temparray[tempIndex].request_quantum = parseFloat(quantityEdit)
    temparray[tempIndex].quantity = parseFloat(quantityEdit)
    temparray[tempIndex].product_name = pname
    temparray[tempIndex].material_number = pnumber
    temparray[tempIndex].product_spec = pspec
    temparray[tempIndex].plant = plantID
    temparray[tempIndex].plant_desc = plantName
    temparray[tempIndex].sloc = sloc
    temparray[tempIndex].sloc_description = slocDesc
    temparray[tempIndex].route = route
    temparray[tempIndex].route_desc = routeDesc
    setAddedProduct(temparray)
    
    let totalPrice = temparray.reduce(
      (a: any, b: any, index: any) => a + (b.quantity * b.request_price || 0),
      0
    )
    setTotalPriceProductBefore(totalPrice)
    // let totalPricePpn = temparray.reduce(
    //   (a: any, b: any, index: any) =>
    //     a +
    //     ((ppn / 100) * (b.quantity * b.request_price) + (b.quantity * b.request_price) || 0),
    //   0
    // )
    let totalPricePpn = temparray.reduce(
      (a: any, b: any, index: any) =>
        a +
        (Math.round(b.quantity * (b.request_price + Math.round((b.request_price / 100) * ppn))) ||
          0),
      0
    )
    let totalquantum = temparray.reduce(
      (a: any, b: any, index: any) => (b.product_type != '8105' ? a + (b.quantity || 0) : a + 0),
      0
    )
    console.log(totalquantum)
    let totalpcs = temparray.reduce(
      (a: any, b: any, index: any) => (b.product_type == '8105' ? a + (b.quantity || 0) : a + 0),
      0
    )
    setTotalPcsProduct(totalpcs)
    swal({
      title: `${t('dataBerhasilDiedit')}`,
      icon: 'success',
    })
    // console.log(totalquantum, totalPrice, totalPricePpn, 'total, before, after')
    setPspec('')
    setPlantName('')
    setSloc('')
    setSlocDesc('')
    setTotalQuantumProduct(totalquantum)
    setTotalPriceProductAfter(totalPricePpn)

    const _signingConfig = signingPayload
    _signingConfig.total_quantum = totalquantum + totalquant
    setSigningPaylod(_signingConfig)
    
    loadSigningConfig()
    cleareFormEditSO()
    setShowEdit2(false)
  }

  const clearState = () => {
    setDisableCKBOX(false)
    setEnduser('')
    setEnduserDesc('')
    setProvinceProduct(0)
    setCityProduct(0)
    setPtype('')
    setPtype2('')
    setFullProductName([])
    setPname('')
    setPnumber('')
    setPspec('')
    setSegment('')
    setSegmentDesc('')
    setSubprice(0)
    setQuantum(0)
    setketerangan('')
  }

  CustomUseEffect(() => {
    const productNameData = async () => {
      await getProductName('', dist, ptype, salesorg, idSector).then((res) => {
        let temp: any[] = []
        // eslint-disable-next-line array-callback-return
        res.data.data.map((item: any) => {
          if (item.material_number != 0)
            temp.push({
              unit: item.base_of_measure,
              value: item.material_number + '_' + item.material_description,
              label: parseInt(item.material_number) + ' - ' +item.material_description,
              truevalue: parseInt(item.material_number),
            })
        })
        setFullProductName(temp)
      })
    }
    productNameData()
  }, [ptype2])

  const handleTambahProduct = async () => {
    clearState()
    await getEndUser('').then((res) => {
      setFullEndUser(res.data.data)
    })

    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })

    await getProductType('').then((res) => {
      setFullProductType(res.data.data)
    })
    setShowAddProduct(true)
  }

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(provinceProduct)
        .then((res) => {
          setLoading(true)
          setFullCity2(
            res.data.data.map((item: any) => {
              return {
                value: item.id + '~#~' + item.value,
                label: item.value,
              }
            })
          )
        })
        .finally(() => setLoading(false))
    }

    getFUllSalesOffice()
  }, [provinceProduct])

  const [downloadOnly, setDownloadOnly] = useState(false)
  const navigate = useNavigate()

  // console.log(editMaterialProd)

  const handleShow3 = () => {
    if (approveState != true) setShow3(true)
    else
      swal({
        title: `${t('berhasil')}`,
        icon: 'success',
      })
  }
  const submitApprove = () => {
    setApproveState(true)
    setShow3(false)
  }

  const handlePrinout = () => {
    if (prinout == 'Printout CO') setPrinoutState(true)
    else setPrinoutState(false)
  }

  const [incotermId, setIncotermId] = useState<any>(0)
  const [incotermId2, setIncotermId2] = useState('')
  const [incotermId2Desc, setIncotermId2Desc] = useState('')
  const [approvalLevel, setApprovalLevel] = useState()
  const [detailSO, setDetailSO] = useState<any>({})
  const [anperEdit, setAnperEdit] = useState(false)
  const [SAPNum, setSAPNum] = useState<any>()
  const [SOSAPNum, setSOSAPNum] = useState<any>(null)
  const [noExport, setNoExport] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()
  const [attachmentType, setAttachmentType] = useState('so-item')

  const {t} = useTranslation()

  const [assessmentHead, setAssessmentHead] = useState(0)
  const [isLoadingPage, setIsLoadingPage] = useState(true)
  const params = useParams()
  const SOID = params.id

  const getSODetail = async () => {
    setIsLoadingPage(true)
    getDetailSO(params.id, localStorage.getItem('credential'))
      .then(async (response) => {
        const data = response.data.data
        appDispatch(setDetailSOContract(response.data.data))
        setSONumber(response.data.data.so_number)
        setCustomerCode(response.data.data.customer.customer_code)
        setStatusText(response.data.data.status_text)
        setProvinsiTujuan(response.data.data.province ? response.data.data.province : '')
        setProvinsiTujuan2(response.data.data.province_desc ? response.data.data.province_desc : '')
        setProvinsiTujuanSource(response.data.data.province ? response.data.data.province : '')
        setProvinsiTujuan2Source(
          response.data.data.province_desc ? response.data.data.province_desc : ''
        )
        setFindoc(response.data.data.findoc?.id)
        setFindoc2(response.data.data.findoc?.num_findoc)
        setSelectedFindoc(response.data.data.findoc?.num_findoc)
        setRegarding(response.data.data.order_sub.regarding)
        let head = response.data.data.customer.customer_code.charAt(0)
        if (head == '2') setAssessmentHead(2)
        else setAssessmentHead(0)
        setLeftoverArray(response.data.data.left_quantum_osd)

        setShipCust(
          response.data.data.customer_ship?.title == null
            ? response.data.data.customer_ship?.name
            : response.data.data.customer_ship?.title + ' ' + response.data.data.customer_ship?.name
        )
        setCustomerTitle(
          response.data.data.customer?.title == null ? '' : response.data.data.customer?.title
        )
        setSalesOrgName(response.data.data.anper?.name)
        getImg(
          response.data.data.sector_id != 2 ? response.data.data.sales_org_code : 'retail'
        )
        setDetailSO(response.data.data)
        setSalesorg(response.data.data.sales_org_code)
        setIncotermId(response.data.data.incoterm1_id)
        setKontrakIncoterm(response.data.data.incoterm1_id)
        setIncotermIdDesc(response.data.data.incoterm1?.code)
        setPPH22(response.data.data.pph22)
        setIncotermId2(response.data.data.incoterm2)
        setApprovalLevel(response.data.data.approval_level)
        setCustomerName(response.data.data.customer.name)
        setCustomerAddress(response.data.data.customer.address)
        setCustomerPreview(response.data.data.customer)
        if (response.data.data.sector_id == 2)
          setEditDisChannel(response.data.data.sip_order?.pengajuan_order?.distribution_channel)
        else
          setEditDisChannel(
            response.data.data.contract?.sip_order?.pengajuan_order?.distribution_channel
          )
        setSODetail(response.data.data.so_items)
        console.log(response.data.data.so_items)
        appDispatch(setOrderItems(response.data.data.so_items))
        const loginRoleFlag = localStorage.getItem('role-flag')
        if (
          response.data.data.approved_level === 0 &&
          (response.data.data.status === 0 || response.data.data.status === 2) &&
          response.data.data.sector_id == 2 &&
          loginRoleFlag == 'salesAnper'
        )
          setIsApprovalAnper(true)

        if (
          response.data.data.approved_level == 0 &&
          (response.data.data.status == 0 ||
            response.data.data.status == 1 ||
            response.data.data.status === 2) &&
          (response.data.data.sector_id == 3 || response.data.data.sector_id == 1) &&
          loginRoleFlag == 'salesAnper'
        )
          setAnperEdit(true)
        setKontrakID(response.data.data.contract?.contract_number)
        setSAPNum(response.data.data.contract?.sap_number)
        setSOSAPNum(response.data.data.sap_number)
        // if (
        //   response.data.data.approved_level == 0 &&
        //   response.data.data.status == 0 &&
        //   loginRoleFlag == 'salesAnper'
        // )
        setEditFlag(true)
        setHydro(response.data.data.hydro_static_table)
        setStowage(response.data.data.stowage_plan)
        setPot(response.data.data.port_of_discharge)
        setCountry(response.data.data.country_destination)
        setProvince(response.data.data.sales_office_detail?.id)
        setPay(response.data.data.payment?.code)
        setPaySAP(response.data.data.payment?.code_sap)
        setBooking(response.data.data.booking_code)
        setSOID(response.data.data.id)
        setShip(response.data.data.file_path)
        setSIP_ID(response.data.data.sip_order_id)
        setIDSector(response.data.data.sector_id)
        setKontrak(response.data.data.contract)
        setSIPOrder(response.data.data.sip_order_id)
        setTrans(response.data.data.moda_angkut_name)
        setTrans2(response.data.data.moda_angkut_name)
        setTransType(response.data.data.moda_angkut_type)
        if (response.data.data.sector_id == 2) setTransType2(response.data.data.moda_angkut_type)
        else setTransType2(response.data.data.moda_angkut_type_en)
        setHydro2(response.data.data.file_path_hydro_static_table)
        setStowage2(response.data.data.stowage_plan)
        setPot2(response.data.data.port_of_discharge)
        setCountry2(response.data.data.country_destination)
        setProvince2(response.data.data.sales_office_detail?.region_name)
        setPay2(response.data.data.payment?.payment_desc)
        setCustGroup(response.data.data.customer_account_group_detail?.code)
        setCustGroup2(response.data.data.customer_account_group_detail?.name)
        setCustAssing(response.data.data.account_assignment_group_detail?.code)
        setCustAssing2(response.data.data.account_assignment_group_detail?.name)

        setTypeTransport(response.data.data.moda_angkut_type)
        setTypeTransportEn(response.data.data.moda_angkut_type_en)
        // if (response.data.data.no_izin_export == null || response.data.data.no_izin_export == '')
        //   setNoExport(response.data.data.contract?.no_izin_export)
        // else setNoExport(response.data.data.no_izin_export)
        // if (response.data.data.assigner_name != '' && response.data.data.assigner_name != null) {
        //   setAssigner(response.data.data.assigner_name)
        //   setAssigner2(response.data.data.assigner_name)
        // } else {
        //   setAssigner(response.data.data.contract?.assigner_name)
        //   setAssigner2(response.data.data.contract?.assigner_name)
        // }
        setAssigner(response.data.data.assigner_name)
        setAssigner2(response.data.data.assigner_name)
        setPosition(response.data.data.assigner_position)
        setPosition2(response.data.data.assigner_position)
        // if (
        //   response.data.data.assigner_position != '' &&
        //   response.data.data.assigner_position != null
        // ) {
        //   setPosition(response.data.data.assigner_position)
        //   setPosition2(response.data.data.assigner_position)
        // } else {
        //   setPosition(response.data.data.contract?.assigner_position)
        //   setPosition2(response.data.data.contract?.assigner_position)
        // }
        if (response.data.data.sector_id == 3) setCurrency('USD ')
        else setCurrency('IDR')
        setCity2(response.data.data.sales_group_detail?.city_name)
        setCity(response.data.data.sales_group_detail?.id)
        setProvince(response.data.data.sales_office_detail?.id)
        setApprovalFlag(response.data.data.show_btn_approve)
        setStatus(response.data.data.status)
        setDist(response.data.data.order_sub?.distribution_channel)
        setCustCode(response.data.data.customer_id)
        setTOP(response.data.data.term_of_payment?.code)
        setTOPDesc(response.data.data.term_of_payment?.top_desc)
        setTOP2(response.data.data.term_of_payment?.code)
        setTOPDesc2(response.data.data.term_of_payment?.top_desc)
        // console.log(response.data.data.term_of_payment?.code)
        setPay1(response.data.data.so_items[0].order_sub_detail.payment_type_1)
        setPay2Product(response.data.data.so_items[0].order_sub_detail.payment_type_2)
        setPay1Desc(response.data.data.so_items[0].order_sub_detail.payment_type_1_desc)
        setPay2Desc(response.data.data.so_items[0].order_sub_detail.payment_type_2_desc)
        setIncotermId2Desc(response.data.data.so_items[0].order_sub_detail.incoterm2_id)
        setFindocLoc(response.data.data.findoc?.file_path)
        let totalPrice = response.data.data.so_items.reduce(
          (a: any, b: any) => a + (b['price_before_ppn'] || 0),
          0
        )
        setPriceBefore(totalPrice)
        let totalPriceAfter = response.data.data.so_items.reduce(
          (a: any, b: any) => a + (b['price_after_ppn'] || 0),
          0
        )
        setPriceAfter(totalPriceAfter)
        setppn(response.data.data.so_items[0].ppn)
        setTotalquant(response.data.data.detail_quantity?.total_tonnase)
        setTotalPcs(response.data.data.detail_quantity?.total_pcs)
        const tempArray: string[] = []
        response.data.data.so_items?.forEach((data: any) => {
          tempArray.push(data.plant_desc)
        })

        setNoExport(response.data.data.additional_texts?.no_izin_export)
        setCustPICName(response.data.data.additional_texts?.customer_pic_name)
        setCustPICName_(response.data.data.additional_texts?.customer_pic_name)
        setCustPICPosition(response.data.data.additional_texts?.customer_pic_position)
        setCustPICPosition_(response.data.data.additional_texts?.customer_pic_position)
        setNamaPenandatanganFinance(response.data.data.additional_texts?.financial_assigner_name)
        setPosisiPenandatanganFinance(response.data.data.additional_texts?.financial_assigner_position)
        setSailingDate(response.data.data.additional_texts?.sailing_date)
        setSailingDate_(
          response.data.data.additional_texts?.sailing_date == '' || response.data.data.additional_texts?.sailing_date == null
            ? null
            : new Date(response.data.data.additional_texts?.sailing_date + ' 00:00:00')
        )
        setPortLoading(response.data.data.additional_texts?.port_of_loading)
        setPortLoading_(response.data.data.additional_texts?.port_of_loading)
        setTextBAST(response.data.data.additional_texts?.additional_text_bast)
        setTextBASTEn(response.data.data.additional_texts?.additional_text_bast_en)
        setTextBAST_(response.data.data.additional_texts?.additional_text_bast)
        setSalesDivision(response.data.data.additional_texts?.sales_division)
        setSalesDivision_(response.data.data.additional_texts?.sales_division)
        setPicSalesDivision(response.data.data.additional_texts?.pic_sales_division)
        setPicSalesDivision_(response.data.data.additional_texts?.pic_sales_division)
        setTOS(response.data.data.additional_texts?.terms_and_conditions)
        setTOSEn(response.data.data.additional_texts?.terms_and_conditions_en)
        setTOS_(response.data.data.additional_texts?.terms_and_conditions)
        setTOSsi(response.data.data.additional_texts?.terms_and_conditions_si)
        setTOSsiEn(response.data.data.additional_texts?.terms_and_conditions_si_en)
        setTOSsi_(response.data.data.additional_texts?.terms_and_conditions_si)
        setAttn(response.data.data.additional_texts?.customer_attn)
        setAttnEn(response.data.data.additional_texts?.customer_attn_en)
        setAttn_(response.data.data.additional_texts?.customer_attn)
        setPenutup(response.data.data.additional_texts?.text_penutup)
        setPenutupEn(response.data.data.additional_texts?.text_penutup_en)
        setPenutup_(response.data.data.additional_texts?.text_penutup)
        setETA(response.data.data.additional_texts?.eta_moda_angkut)
        setETA_(
          response.data.data.additional_texts?.eta_moda_angkut == '' || response.data.data.additional_texts?.eta_moda_angkut == null
            ? null
            : new Date(response.data.data.additional_texts?.eta_moda_angkut + ' 00:00:00')
        )
        setTextKeterangan(response.data.data.additional_texts?.keterangan)
        setTextKeteranganEn(response.data.data.additional_texts?.keterangan_en)
        setTextKeterangan_(response.data.data.additional_texts?.keterangan)
        setReferensi(response.data.data.additional_texts?.referensi)
        setReferensiEn(response.data.data.additional_texts?.referensi_en)
        // setReferensi_(response.data.data.additional_texts?.referensi)
        setShippingInstruction(response.data.data.additional_texts?.tanggal_shipping_instruction)
        setShippingInstruction_(
          response.data.data.additional_texts?.tanggal_shipping_instruction == '' ||
            response.data.data.additional_texts?.tanggal_shipping_instruction == null
            ? null
            : new Date(response.data.data.additional_texts?.tanggal_shipping_instruction + ' 00:00:00')
        )
        setInvoice(response.data.data.additional_texts?.invoice_notes)
        setInvoiceEn(response.data.data.additional_texts?.invoice_notes_en)
        setInvoice_(response.data.data.additional_texts?.invoice_notes)
        setPickupDate(response.data.data.contract?.validity_date_to)

        getSubContract(response.data.data.contract_id)

        const _signingConfig = signingPayload
        _signingConfig.province_id = data?.sales_office_detail?.id
        _signingConfig.city_id = data?.sales_group_detail?.id
        _signingConfig.sales_org_code = data?.sales_org_code
        _signingConfig.sector_id = data?.sector_id
        _signingConfig.total_quantum = data?.total_quantum_so

        if(data.so_items){
          if(data.so_items[0] && data.so_items[0].order_sub_detail){
            _signingConfig.product_type = data.so_items[0].order_sub_detail.product_type
          }
        }
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        const getAcc = async () => {
          let temp = 0
          if (head != 1) temp = 2
          else temp = 0
          const res = await getAccAssSO(
            temp,
            response.data.data.customer_account_group_detail?.code
          )
          setLoading(true)

          setFullAssign(
            res.data.data.map((item: any) => {
              if (item.customer_head == temp) {
                setCustAssing(item.account_assignment_group_code)
                setCustAssing2(item.account_assignment_group.name)
              }
              return {
                value: item.account_assignment_group.code,
                label: item.account_assignment_group.name,
              }
            })
          )
          setLoading(false)
        }

        getAcc()
      })
      .finally(() => setIsLoadingPage(false))
  }

  const [contractItems, setContractItems] = useState<any>([])

  const getSubContract = async (id: any) => {
    
    await getSODetailContract(id, localStorage.getItem('credential')).then(async (response) => {
      const osd = response.data.data.order_sub_details
      setContractItems(osd)
    })
  }

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const handleLefoverObject = (idosd: any, quantity: any) => {
    let temp = leftoverArray.findIndex((item: any) => item.order_sub_detail_id == idosd)
    setLeftoverIndex(temp)
    setTotalBatas(parseFloat(leftoverArray[temp].left_over_quantum) + parseFloat(quantity))
    setTotalBatasNonST(
      parseFloat(leftoverArray[temp].left_over_quantum_no_st) + parseFloat(quantity)
    )
    setSisa(parseFloat(leftoverArray[temp].left_over_quantum))
    setSisaNoST(parseFloat(leftoverArray[temp].left_over_quantum_no_st))
  }

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    if (fold) {
      fold.classList.toggle('foldd-open')
    }
  }

  const [sailingDate, setSailingDate] = useState<any>(null)
  const [custPICName, setCustPICName] = useState<any>(null)
  const [custPICPosition, setCustPICPosition] = useState<any>(null)
  const [namaPenandatanganFinance, setNamaPenandatanganFinance] = useState<any>(null)
  const [posisiPenandatanganFinance, setPosisiPenandatanganFinance] = useState<any>(null)
  const [portLoading, setPortLoading] = useState<any>(null)
  const [textBAST, setTextBAST] = useState<any>(null)
  const [textBASTEn, setTextBASTEn] = useState<any>(null)
  const [salesDivision, setSalesDivision] = useState<any>(null)
  const [picSalesDivision, setPicSalesDivision] = useState<any>(null)
  const [transportMedia, setTransportMedia] = useState<any>(null)
  const [transportMediaInfo, setTransportMediaInfo] = useState<any>(null)
  const [TOS, setTOS] = useState<any>(null)
  const [TOSEn, setTOSEn] = useState<any>(null)
  const [TOSsi, setTOSsi] = useState<any>(null)
  const [TOSsiEn, setTOSsiEn] = useState<any>(null)
  const [attn, setAttn] = useState<any>(null)
  const [attnEn, setAttnEn] = useState<any>(null)
  const [penutup, setPenutup] = useState<any>(null)
  const [penutupEn, setPenutupEn] = useState<any>(null)
  const [ETA, setETA] = useState<any>(null)
  const [textKeterangan, setTextKeterangan] = useState<any>(null)
  const [textKeteranganEn, setTextKeteranganEn] = useState<any>(null)
  const [referensiEn, setReferensiEn] = useState<any>(null)
  const [shippingInstruction, setShippingInstruction] = useState<any>(null)
  const [invoice, setInvoice] = useState<any>(null)
  const [invoiceEn, setInvoiceEn] = useState<any>(null)

  const [sailingDate_, setSailingDate_] = useState<any>('')
  const [custPICName_, setCustPICName_] = useState('')
  const [custPICPosition_, setCustPICPosition_] = useState('')
  const [portLoading_, setPortLoading_] = useState<any>('')
  const [textBAST_, setTextBAST_] = useState<any>('')
  const [salesDivision_, setSalesDivision_] = useState<any>('')
  const [picSalesDivision_, setPicSalesDivision_] = useState<any>('')
  const [transportMedia_, setTransportMedia_] = useState<any>('')
  const [transportMediaInfo_, setTransportMediaInfo_] = useState<any>('')
  const [TOS_, setTOS_] = useState<any>('')
  const [TOSsi_, setTOSsi_] = useState<any>('')
  const [attn_, setAttn_] = useState<any>('')
  const [penutup_, setPenutup_] = useState<any>('')
  const [ETA_, setETA_] = useState<any>('')
  const [textKeterangan_, setTextKeterangan_] = useState<any>('')
  const [referensi, setReferensi] = useState<any>('')
  const [shippingInstruction_, setShippingInstruction_] = useState<any>('')
  const [invoice_, setInvoice_] = useState<any>('')
  const [noExport_, setNoExport_] = useState('')

  const [showAdditional, setShowAdditional] = useState(false)

  const handleSaveAdditionalText = (id: any, state: any, value: any) => {
    if (value == '') state(null)
    else state(value)
    let close = document.getElementById('target' + id) as HTMLInputElement
    // console.log(close)
    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t(id)}`,
      icon: 'success',
    })
  }

  const handleSaveAdditionalText2 = (id: any, state: any, value: any, state2: any) => {
    state(convertDatePicker(new Date(value.target.value)))
    state2(value.target.value)
  }

  const handleSyncSAP = async () => {
    setLoadingSAP(true)
    await syncSO({
      lang: i18next.language,
      sap_number: SOSAPNum,
      credentials: localStorage.getItem('credential'),
    })
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        }).then(() => {
          getSODetail()
        })
        getSODetail()
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setLoadingSAP(false)
      })
  }
  // console.log(selectedFindoc)
  CustomUseEffect(() => {
    const getAcc = async () => {
      const res = await getAccAssSO(assessmentHead, custGroup)
      setFullAssign(
        res.data.data.map((item: any) => {
          if (item.customer_head == assessmentHead) {
            setCustAssing(item.account_assignment_group_code)
            setCustAssing2(item.account_assignment_group.name)
          }
          return {
            value: item.account_assignment_group.code,
            label: item.account_assignment_group.name,
          }
        })
      )
    }
    getAcc()
  }, [custGroup])

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(province)
        .then((res) => {
          setLoading(true)
          setFullCity(
            res.data.data.map((item: any) => {
              return {
                value: item.id,
                label: item.value,
              }
            })
          )
        })
        .finally(() => setLoading(false))
    }
    getFUllSalesOffice()
  }, [province])

  CustomUseEffect(() => {
    const getAllProvince = async () => {
      await getProvince2(salesorg, dist)
        .then((res) => {
          setLoading(true)
          setFullProvince(
            res.data.data.map((item: any) => {
              return {
                value: parseInt(item.sales_office),
                label: item.description,
              }
            })
          )
        })
        .finally(() => setLoading(false))
    }
    getAllProvince()
  }, [salesorg, dist])

  CustomUseEffect(() => {
    let totalPrice = SODetail.reduce((a: any, b: any) => a + (b['price_before_ppn'] || 0), 0)
    setPriceBefore(totalPrice)
    let totalPriceAfter = SODetail.reduce((a: any, b: any) => a + (b['price_after_ppn'] || 0), 0)
    setPriceAfter(totalPriceAfter)
    let totalquantum = SODetail.reduce(
      (a: any, b: any) =>
        b.order_sub_detail.product_type != '8105' ? a + (b['quantity'] || 0) : a + 0,
      0
    )
    setppn(SODetail.length < 1 ? 0 : SODetail[0]?.ppn)
    setTotalquant(totalquantum)
    let totalpcs = SODetail.reduce(
      (a: any, b: any) =>
        b.order_sub_detail.product_type == '8105' ? a + (b['quantity'] || 0) : a + 0,
      0
    )
    setTotalPcs(totalpcs)
  }, [SODetail])

  const clearfindoc = () => {
    setFindoc('')
    setSelectedFindoc('')
    setTOP('')
    setTOP2('')
  }

  // CustomUseEffect(() => {
  //   setFindoc('')
  //   setSelectedFindoc('')
  //   setTOP('')
  //   setTOP2('')
  // }, [incotermId, incotermId2])

  CustomUseEffect(() => {
    const materialNumber = detailItem?.material_number || ''
    const getPlantLoc = async () => {
      await getSloc(plantID, '', materialNumber, '', '').then((res) => {
        setFullSloc(
          res.data.data.map((item: any) => {
            return {
              value: item.sloc + '~#~' + item.sloc_description,
              label: item.sloc + '-' + item.sloc_description,
            }
          })
        )
      })
    }
    getPlantLoc()
  }, [plantID])

  const separator2 = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')

    state1(temp[0])
    state2(temp[1])
    if (temp[1] == 'Truck') {
      setFilesHydro(null)
      // setFilesHydroName('')
      setFilesShip(null)
      // setFilesShipName('')
    }
  }

  const separator3 = (value: any, state1: any, state2: any) => {
    const temp = value.split('_')
    state1(temp[0])
    state2(temp[1])
  }

  const sumSimiarEdit = (func1: any, add: any, index: any) => {
    let temp = 0
    func1.forEach((data: any) => {
      temp = temp + data.quantity
    })
    temp = temp - func1[index].quantity + add
    // console.log(temp)
    return temp
  }

  const [pspec, setPspec] = useState<any>('')
  // console.log(SODetail, 'index', tempIndex)
  const editPlantSO = async () => {
    if (idSector != 2) {
      if (totalbatas >= parseFloat(quantityEdit) && parseFloat(quantityEdit) != 0) {
        setBtnLoading(true)
        let tempArray: any = [...SODetail]
        let tempquantum: any = 0
        let tempbefore: any = 0
        let tempafter: any = 0
        let tempBatas: any = []

        tempBatas = leftoverArray.map((item: any, _idx: number) => {
          const leftOverQuantum = item?.left_over_quantum ?? 0
          const leftOverQuantumSt = item?.left_over_quantum_no_st ?? 0
          const editedQty = parseFloat(quantityEdit)
          const qty = tempArray[tempIndex]?.quantity ?? 0
          return leftoverIndex == _idx ? {
            ...item,
            left_over_quantum: (leftOverQuantum + qty) - editedQty,
            left_over_quantum_no_st: (leftOverQuantumSt + qty) - editedQty,
          } : item
        })

        if (quantityEdit < tempArray[tempIndex]?.quantity) {
          if (!contractItems.find((item: any) => item.id == tempArray[tempIndex]?.order_sub_detail.id)) {
            setContractItems([... contractItems, (tempArray[tempIndex]?.order_sub_detail || {})])
          }
        }

        tempArray[tempIndex] = {
          ...tempArray[tempIndex],
          quantity: parseFloat(quantityEdit)
        }
        setLeftoverArray(tempBatas)
        setTotalBatas(0)
        setTotalBatasNonST(0)
        setLeftoverIndex(0)

        let totalquantum = tempArray.reduce(
          (a: any, b: any) =>
            b.order_sub_detail.product_type != '8105' ? a + (b['quantity'] || 0) : a + 0,
          0
        )

        setTotalquant(totalquantum)
        let totalpcs = tempArray.reduce(
          (a: any, b: any) =>
            b.order_sub_detail.product_type == '8105' ? a + (b['quantity'] || 0) : a + 0,
          0
        )
        setTotalPcs(totalpcs)
        tempArray.forEach((item: any) => {
          tempbefore = parseFloat(tempbefore) + item.quantity * item.price
        })
        setPriceBefore(tempbefore)

        tempArray.forEach((item: any) => {
          tempafter =
            tempafter +
            Math.round(item.quantity * (Math.round(item.price) + Math.round((item.price / 100) * item.ppn)))
        })
        setPriceAfter(tempafter)

        let inc1 = fullIncoterm?.find((item: any) => {
          let expl = item.value?.split("~#~")
          return expl[0] == incoterm
        })
        setSODetail(
          tempArray.map((item: any, _index: number) => (
                _index == tempIndex ? {
                ...item,
                incoterm1_id: incoterm,
                incoterm2: incoterm2,
                incoterm1: inc1 ? {
                  id: incoterm,
                  code: inc1?.label
                } : null,
                incoterm2_id: null,
                quantity: parseFloat(quantityEdit),
                plant: plantID,
                plant_desc: plantName,
                sloc: sloc,
                sloc_description: slocDesc,
                product_spec: pspec,
                route: route,
                route_desc: routeDesc,
                note: note,
                order_sub_detail: {
                  ...item.order_sub_detail,
                  product_spec: pspec,
                  notes: note,
                },
                price_before_ppn: parseFloat(quantityEdit) * tempArray[tempIndex].price,
                price_after_ppn: Math.round(quantityEdit * (
                  Math.round(tempArray[tempIndex].price) + Math.round((tempArray[tempIndex].price / 100) * tempArray[tempIndex]?.ppn))
                ),
                shipping_tolerance: shipping_tolerance,
              } : item
            )
          )
        )

        setRouteDesc('')

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalQuantumProduct
        setSigningPaylod(_signingConfig)
          
        loadSigningConfig()

        swal({
          title: `${t('dataBerhasilDiedit')}`,
          icon: 'success',
        })
          .then(() => {
            cleareFormEditSO()
            setShow(false)
          })
          .finally(() => setBtnLoading(false))
      } else {
        if (parseFloat(quantityEdit) == 0 || isNaN(quantityEdit)) {
          swal({
            title: t('Kuantum tidak boleh kosong!'),
            icon: 'error',
          })
        } else {
          swal({
            title: t('Melebihi quantum yang di setujui!'),
            icon: 'error',
          })
        }
      }
    } else {
      setBtnLoading(true)
      let tempArray: any = [...SODetail]

      const updatedData = tempArray.map((item: any, index: any) => {
        if (index !== tempIndex) return item
        return {
          ...item,
          plant: plantID,
          pant_desc: plantName,
          sloc: sloc,
          route: route,
          route_desc: routeDesc,
          sloc_description: slocDesc,
        }
      })

      setSODetail(updatedData)

      swal({
        title: `${t('dataBerhasilDiedit')}`,
        icon: 'success',
      })
        .then(() => {
          setShow(false)
        })
        .finally(() => setBtnLoading(false))
    }
  }

  const cleareFormEditSO = () => {
    setSloc('')
    setSlocDesc('')
    setTempQuant('')
    setPlantName('')
    setPlantID('')
    setSloc('')
    setSlocDesc('')
    setRouteDesc('')
    setRoute('')
    setNote('')
    setPspec('')
  }

  CustomUseEffect(() => {
    if (roleUser == null || roleUser == 'null') {
      if (kontrak == null || kontrak?.sip_order?.id == 0) {
        const getAllPayment = async () => {
          await getPaymentSO(SIPOrder).then((res) => {
            setFullPayment(res.data.data)
          })
        }
        getAllPayment()
      } else {
        // console.log(kontrak)
        const getAllPayment = async () => {
          await getPaymentSO(kontrak?.sip_order?.id).then((res) => {
            setFullPayment(res.data.data)
          })
        }
        getAllPayment()
      }
    } else {
      const getAllPayment = async () => {
        await getAllPaymentList().then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    }
  }, [kontrak])

  const findPPN = (before: any, after: any) => {
    let ppn = 0.0
    ppn = ((after - before) / before) * 100
    return ppn
  }

  const printoutSO = async (so: any) => {
    await printSO(so).then((response) => {})
  }

  // const Approve = async () => {
  //     await approveSO(parseInt(sessionStorage.getItem("id")!), assinger, position).then(
  //         (res)=> {
  //             console.log(res.data);
  //     if(!res.data.error){
  //         swal({
  //             title: "Approve Success!",
  //             icon: "success",
  //         });
  //         setShowApprove(false)
  //     } else
  //     alert(res.data)
  //         }
  //     )
  // }

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const tempArray2: any[] = [...SODetail]
        const itemDeleting = tempArray2[index]
        console.log(itemDeleting)
        tempArray2.splice(index, 1)
        setSODetail(tempArray2)
        console.log(contractItems, itemDeleting)

        if (!contractItems.find((item: any) => item.id == itemDeleting?.order_sub_detail.id)) {
          setContractItems([... contractItems, (itemDeleting?.order_sub_detail || {})])
        }

        setLeftoverArray(leftoverArray.map((item: any) => {
          return item.order_sub_detail_id == (itemDeleting.item_id || itemDeleting.id) ? {
            ... item,
            left_over_quantum: (item.left_over_quantum + itemDeleting.quantity),
            left_over_quantum_no_st: (item.left_over_quantum_no_st + itemDeleting.quantity),
          } : item
        }))

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = tempArray2.reduce((prev, curr: any) => {
          if (curr.product_type != '8105') {
            return prev + curr.quantity;
          } else {
            return prev
          }
        }, 0)

        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        swal({
          title: `${t('Item SO deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const Reject = async () => {
    setBtnLoading(true)
    await rejectSO(parseInt(sessionStorage.getItem('id')!), rejectNote)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('SO Rejected Success')}`,
            icon: 'success',
          })
          setShowReject(false)
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        dispath(setGetNotif(!notif))
        setBtnLoading(false)
      })
  }

  const [top, setTOP] = useState('')
  const [top2, setTOP2] = useState('')
  const [fullTOP, setFullTOP] = useState([])
  const [allFindoc, setAllFindoc] = useState([])
  const [findoc, setFindoc] = useState('')
  const [findoc2, setFindoc2] = useState('')

  CustomUseEffect(() => {
    if (roleUser == 'null' || roleUser == null) {
      const getAllPayment = async () => {
        await getPaymentSO(SIPOrder).then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    } else {
      const getAllPayment = async () => {
        await getAllPaymentList().then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    }
  }, [SIPOrder])

  CustomUseEffect(() => {
    const getAllFindoc = async () => {
      await getFindocDataTable(custCode, salesorg, '', '', currency).then((res) => {
        setAllFindoc(res.data.data.data)
      })
    }
    hitTOP()
    getAllFindoc()
  }, [custCode])

  const separator = (value: any, state1: any, state2: any, state3: any, state4: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
    state3(temp[2])
    state4(temp[3])
  }

  const hitTOP = async () => {
    const getData = setTimeout(async () => {
      if (roleUser == null || roleUser == 'null') {
        await getTOPCust(custCode).then((res) => {
          setFullTOP(res.data.data)
        })
      } else {
        await getTOPAnper().then((res) => {
          setFullTOP(res.data.data)
        })
      }
    }, 500)

    return () => clearTimeout(getData)
  }

  const condTOP = (top: any) => {
    let trimmedTOP = ''
    if (top?.slice(1, 100) != undefined)
      trimmedTOP = 'Within ' + top?.slice(1, 100) + t(' days Due net')
    if (top == 'Z0LC') return 'Letter of Credit TOP'
    else if (top == 'Z000') return 'Payable immediately Due net'
    else if (top != 'Z0LC' && top != 'Z000') return trimmedTOP
  }
  const [showUpload, setShowUpload] = useState(false)
  const [showUploadHydro, setShowUploadHydro] = useState(false)
  const [showUpload2, setShowUpload2] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [showAddSO, setShowAddSO] = useState(false)

  const closeupload = () => {
    const btn = document.getElementById('btnupload1') as HTMLInputElement
    const btn2 = document.getElementById('btnupload2') as HTMLInputElement

    if (filesHydro != null) if (btn2 != null) btn2.disabled = true

    if (filesShip != null) if (btn != null) btn.disabled = true

    setShowUpload(false)
    setShowUpload2(false)
    setShowUploadHydro(false)
  }

  const ambilAttachment = async (id: any, type: any = null) => {
    if(type) setAttachmentType(type)
    await getFile(type || attachmentType, id, localStorage.getItem('credential')!).then((res) => {
    const files = res.data.data ?? [];
    if(type == 'sales-order'){
      setAllFiles(files)
      setShowUpload(true)
    } else if (type == 'order-item') {
      setAllFiles(files.filter((item: any) => item.attach_parent == id))
    } else {
      setAllFiles(files)
    }

    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    if (input1 != null) input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    if (input2 != null) input2.value = ''
    const input3 = document.getElementById('uploadketerangan2') as HTMLInputElement
    if (input3 != null) input3.value = ''
    const input4 = document.getElementById('upload2') as HTMLInputElement
    if (input4 != null) input4.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setTempRole([])
    setIsPrivate(false)
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            attachmentType == 'sales-order' ?
              ambilAttachment(subOrderID) :
              ambilAttachment(tempData.order_sub_item_id || tempData.id)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // if(idSector != 2){
    //   formdata.append('unique_number', SONumber)
    //   formdata.append('unique_flag', 'new_so_osd')
    // }
    // console.log(formdata)
    await create(attachmentType, formdata)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          ambilAttachment(subOrderID)
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      setSubprice(0)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)
      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            if (status > 4) {
              setFullCity2([])
              setCityProduct(0)
              setCityDesc('')
            }
          }
        }
      }
    } else if (status == 'province') {
      setCityProduct(0)
      setCityDesc('')
    } else if (status == 'tipe') {
      setPname('')
      setPnumber('')
    }
  }

  const checkHydroTransType = (type: string) => {
    if (filesHydro) {
      if (type == 'Kapal') {
        let file = filesHydro?.split('base64,')
        return file[1] || undefined
      }
      return undefined
    } else {
      return
    }
  }

  const checkShipTransType = (type: string) => {
    if (filesShip) {
      if (type == 'Kapal') {
        let file = filesShip?.split('base64,')
        return file[1] || undefined
      }
      return undefined
    } else {
      return
    }
  }

  const checkShipName = (type: string) => {
    if (filesShipName) {
      if (type == 'Kapal') {
        return filesShipName || undefined
      }
      return undefined
    } else {
      return
    }
  }
  const checkHydroName = (type: string) => {
    if (filesHydroName) {
      if (type == 'Kapal') {
        return filesHydroName || undefined
      }
      return undefined
    } else {
      return
    }
  }

  const create2 = async () => {
    let tempcustID = ''
    if (customerID == undefined) tempcustID = ''
    else tempcustID = customerID
    let file = files.file
    let tempincoterm: any = ''
    const orderitemArray: any[] = []
    addedProduct.forEach((data: any, _index: any) => {
      orderitemArray.push(data)
      data?.attachments.forEach((data2: any, _index2: any) => {
        if (data?.attachments?.length > -1) {
          const temp = data2?.file_r.split(',')
          if (temp[1] != undefined) orderitemArray[_index]!.attachments[_index2]!.file_r = temp[1]
        }
      })
    })

    const soItem = SODetail.map((item: any) => ({
      ... item,
      attachments: item.attachments ? item.attachments.map((file: any) => {
        return {
          ... file,
          file_r: file.file_r ? (file.file_r.split(',')[1] || '') : ''
        }
      }) : []
    }))

    if (incotermId == 0) tempincoterm = ''
    else tempincoterm = incotermId
    let data = {}
    if (idSector == 2) {
      let tempinco1: any = incotermId
      // if (incotermId == 0 || incotermId == '') tempinco1 = kontrakIncoterm
      // else tempinco1 = incotermId
      let payload: any[] = []
      soItem.forEach((item: any) => {
        let temp = {
          id: item.id,
          plant: item.plant,
          plant_desc: item.plant_desc,
          sloc: item.sloc,
          sloc_description: item.sloc_description,
          shipping_tolerance: item.shipping_tolerance ?? 0,
          quantity: item.quantity,
          route: item.route,
          route_desc: item.route_desc,
          is_new_product: false
        }
        payload.push(temp)
      })
      data = {
        moda_angkut_name: trans,
        moda_angkut_type: transType,
        moda_angkut_type_en: transType2,
        hydro_static_table: hydro,
        stowage_plan: stowage,
        port_of_discharge: pot,
        country_destination: country,
        payment_type: pay,
        assigner_name: assinger,
        assigner_position: position,
        top: top,
        findoc_id: findoc,
        incoterm1_id: tempinco1,
        incoterm2: incotermId2,
        sales_office: province,
        sales_group: city,
        so_items: payload,
        province: provinsiTujuan,
        province_desc: provinsiTujuan2,
        hydro_static_table_r: checkHydroTransType(transType),
        ship_particular_r: checkShipTransType(transType),
        hydro_static_table_r_name: checkHydroName(transType),
        ship_particular_r_name: checkShipName(transType),
      }
    } else if (idSector == 3) {
      let payload: any[] = []
      soItem.forEach((item: any) => {
        let temp = {
          id: item.item_id || item.id,
          item_id: item.item_id ? item.id : null,
          plant: item.plant,
          plant_desc: item.plant_desc,
          sloc: item.sloc,
          sloc_description: item.sloc_description,
          shipping_tolerance: item.shipping_tolerance ?? 0,
          quantity: item.quantity,
          product_spec: item.product_spec,
          route: item.route,
          route_desc: item.route_desc,
          product_type: item.order_sub_detail.product_type,
          incoterm1_id: item.incoterm1_id,
          incoterm2: item.incoterm2,
          is_new_product: false,
          notes: item.note || '',
          attachments: item.attachments || []
        }
        payload.push(temp)
      })
      addedProduct.forEach((item: any) => {
        let temp = {
          sales_org_code: item.sales_org_code,
          incoterm1_id: item.incoterm1_id,
          incoterm2: item.incoterm2_id,
          product_type: item.product_type,
          product_type_desc: item.product_type_desc,
          product_name: item.product_name,
          product_spec: item.product_spec,
          request_price: item.request_price,
          request_quantum: item.request_quantum,
          province_id: parseInt(item.province_id),
          city_id: parseInt(item.city_id),
          shipping_tolerance: item.shipping_tolerance,
          sector_id: item.sector_id,
          end_user: item.end_user,
          notes: item.notes,
          material_number: item.material_number,
          unit: item.unit,
          segment_code: item.segment_code,
          segment_name: item.segment_name,
          plant: item.plant,
          plant_desc: item.plant_desc,
          sloc: item.sloc,
          sloc_description: item.sloc_description,
          route: item.route,
          route_desc: item.route_desc,
          attachments: item.attachments,
          schedules: item.schedules,
          end_user_multiple: item.end_user_multiple,
          is_new_product: true
        }
        payload.push(temp)
      })
      data = {
        moda_angkut_name: trans,
        moda_angkut_type: transType,
        moda_angkut_type_en: transType2,
        stowage_plan: stowage,
        port_of_discharge: pot,
        country_destination: country,
        payment_type: pay,
        assigner_name: assinger,
        assigner_position: position,
        top: top,
        findoc_id: findoc,
        incoterm1_id: tempincoterm,
        incoterm2: incotermId2,
        sales_office: province,
        sales_group: city,
        customer_account_group: custGroup,
        account_assignment_group: custAssign,
        customer_ship_to: tempcustID,
        so_items: payload,
        customer_pic_name: custPICName,
        customer_pic_position: custPICPosition,
        financial_assigner_name: namaPenandatanganFinance,
        financial_assigner_position: posisiPenandatanganFinance,
        sailing_date: sailingDate,
        port_of_loading: portLoading,
        additional_text_bast: textBAST,
        sales_division: salesDivision,
        pic_sales_division: picSalesDivision,
        terms_and_conditions: TOS,
        terms_and_conditions_si: TOSsi,
        customer_attn: attn,
        text_penutup: penutup,
        keterangan: textKeterangan,
        referensi: referensi,
        tanggal_shipping_instruction: shippingInstruction,
        invoice_notes: invoice,
        eta_moda_angkut: ETA,
        hydro_static_table_r: checkHydroTransType(transType),
        ship_particular_r: checkShipTransType(transType),
        hydro_static_table_r_name: checkHydroName(transType),
        ship_particular_r_name: checkShipName(transType),
      }
    } else if (idSector == 1) {
      let payload: any[] = []
      soItem.forEach((item: any) => {
        let temp = {
          id: item.item_id || item.id,
          item_id: item.item_id ? item.id : null,
          plant: item.plant,
          plant_desc: item.plant_desc,
          sloc: item.sloc,
          sloc_description: item.sloc_description,
          shipping_tolerance: item.shipping_tolerance ?? 0,
          quantity: item.quantity,
          product_spec: item.product_spec,
          route: item.route,
          route_desc: item.route_desc,
          product_type: item.order_sub_detail.product_type,
          incoterm1_id: item.incoterm1_id,
          incoterm2: item.incoterm2,
          is_new_product: false,
          notes: item.note || '',
          attachments: item.attachments || []
        }
        payload.push(temp)
      })
      addedProduct.forEach((item: any) => {
        let temp = {
          sales_org_code: item.sales_org_code,
          incoterm1_id: item.incoterm1_id,
          incoterm2: item.incoterm2_id,
          product_type: item.product_type,
          product_type_desc: item.product_type_desc,
          product_name: item.product_name,
          product_spec: item.product_spec,
          request_price: item.request_price,
          request_quantum: item.request_quantum,
          province_id: parseInt(item.province_id),
          city_id: parseInt(item.city_id),
          shipping_tolerance: item.shipping_tolerance,
          sector_id: item.sector_id,
          end_user: item.end_user,
          notes: item.notes,
          material_number: item.material_number,
          unit: item.unit,
          segment_code: item.segment_code,
          segment_name: item.segment_name,
          plant: item.plant,
          plant_desc: item.plant_desc,
          sloc: item.sloc,
          sloc_description: item.sloc_description,
          route: item.route,
          route_desc: item.route_desc,
          attachments: item.attachments,
          schedules: item.schedules,
          end_user_multiple: item.end_user_multiple,
          is_new_product: true
        }
        payload.push(temp)
      })
      data = {
        moda_angkut_name: trans,
        moda_angkut_type: transType,
        moda_angkut_type_en: transType2,
        stowage_plan: stowage,
        port_of_discharge: pot,
        country_destination: country,
        payment_type: pay,
        assigner_name: assinger,
        assigner_position: position,
        top: top,
        findoc_id: findoc,
        incoterm1_id: tempincoterm,
        incoterm2: incotermId2,
        sales_office: province,
        sales_group: city,
        customer_account_group: custGroup,
        account_assignment_group: custAssign,
        province: provinsiTujuan,
        province_desc: provinsiTujuan2,
        customer_ship_to: tempcustID,
        so_items: payload,
        customer_pic_name: custPICName || '',
        customer_pic_position: custPICPosition || '',
        financial_assigner_name: namaPenandatanganFinance || '',
        financial_assigner_position: posisiPenandatanganFinance || '',
        sailing_date: sailingDate || '',
        port_of_loading: portLoading || '',
        additional_text_bast: textBAST || '',
        additional_text_bast_en: textBASTEn || '',
        sales_division: salesDivision,
        pic_sales_division: picSalesDivision || '',
        terms_and_conditions: TOS || '',
        terms_and_conditions_en: TOSEn || '',
        terms_and_conditions_si: TOSsi || '',
        terms_and_conditions_si_en: TOSsiEn || '',
        customer_attn: attn || '',
        customer_attn_en: attnEn || '',
        text_penutup: penutup || '',
        text_penutup_en: penutupEn || '',
        keterangan: textKeterangan || '',
        keterangan_en: textKeteranganEn || '',
        referensi: referensi || '',
        referensi_en: referensiEn || '',
        tanggal_shipping_instruction: shippingInstruction || '',
        invoice_notes: invoice || '',
        invoice_notes_en: invoiceEn || '',
        eta_moda_angkut: ETA || '',
        no_izin_export: noExport,
        hydro_static_table_r: checkHydroTransType(transType),
        ship_particular_r: checkShipTransType(transType),
        hydro_static_table_r_name: checkHydroName(transType),
        ship_particular_r_name: checkShipName(transType),
      }
    }

    let lang = 'en'
    if (i18next.language == 'en') lang = 'en'
    else lang = 'id'

    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
    }).then(async (accept) => {
      if (accept) {
        setBtnLoading(true)
        await resubmitSO(
          params.id,
          localStorage.getItem('credential')!,
          data,
          lang
        )
        .then((response) => {
          swal({
            title: `${t(response.data.message)}`,
            icon: 'success',
          }).then(() => {
            navigate('/management/so')
          })
          setShowApprove(false)
          setIsApprove(true)
        })
        .catch(function (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        })
        .finally(() => {
          dispath(setGetNotif(!notif))
          setBtnLoading(false)
        })
      }
    })
  }

  const [fullCust, setFullCust] = useState<any>([])
  const [fullAssign, setFullAssign] = useState<any>([])
  const [custAssign, setCustAssing] = useState('')
  const [sektorId, setSektorId] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [fullProvince2, setFullProvince2] = useState<any>([])

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const allIncoterm = async () => {
      await getIncoterm()
        .then((res) => {
          setLoading(true)
          let temparray: any[] = [{value: '0~#~', label: t('Pilih-incoterm')}]
          res.data.data.forEach((item: any) => {
            temparray.push({value: item.id + '~#~' + item.code, label: item.code})
          })
          setFullIncoterm(temparray)
        })
        .finally(() => setLoading(false))
    }
    const getCust = async () => {
      const res = await getCusGrup(sektorId)
      setLoading(true)
      setFullCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
      setLoading(false)
    }

    const getTransport = async () => {
      const res = await getAllTransport()
      setFullTransport(res.data.data)
    }

    const getprov = async () => {
      await getProvince3().then((res) => {
        // console.log(res.data, ' prov')
        setFullProvince2(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
    }
    // const getPPNValue = async () => {
    //   await getPPN().then((res) => {
    //     setPPN2(res.data.data.data[0].ppn)
    //   })
    // }
    // getPPNValue()

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    handleYear()
    getprov()
    getTransport()
    getCust()
    getAccessMenu()
    allIncoterm()
    role()
    getSODetail()
    getAllRoleList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlebrowsefindoc = async () => {
    await getFindocDataTable(custCode, salesorg, incotermId, incotermId2, currency).then((res) => {
      setAllFindoc(res.data.data.data)
    })
    const getData = setTimeout(async () => {
      setShowBrowseFindoc(true)
    }, 1000)
    return () => clearTimeout(getData)
  }

  const separateValue2 = (state: any, value: any) => {
    const temp = value
    state(parseInt(temp))
  }

  const [fullPlant, setFullPlant] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [loadingSAP, setLoadingSAP] = useState(false)
  const [detailItem, setDetailItem] = useState<any>([])
  const [detailId, setDetailId] = useState<any>([])

  const handleEditPlant = async (mat: any, detail: any, id: any, quantity: any, type: any = '') => {
    setDetailItem(detail)
    
    setDetailId(id)
    setQuantityEdit(quantity)
    // console.log(detail)
    setLoading(true)
    await getPlant2(salesorg, dist, mat)
      .then((res) => {
        setFullPlant(
          res.data.data.map((item: any) => {
            return {
              value: item.plant + '~#~' + item.plant_name,
              label: item.plant + '-' + item.plant_name,
            }
          })
        )
      })
      .then(() => {
        setLoading(false)
      })

    // const materialNumber = orderItem?.material_number ?? orderItem?.order_sub_detail?.material_number ?? ''

    // await getSloc(plantID, '', materialNumber, '', '').then((res) => {
    //   setFullSloc(
    //     res.data.data.map((item: any) => {
    //       return {
    //         value: item.sloc + '~#~' + item.sloc_description,
    //         label: item.sloc + '-' + item.sloc_description,
    //       }
    //     })
    //   )
    // })

    await getRoute(salesorg).then((res) => {
      setFullRoute(
        res.data.data.map((item: any) => {
          return {
            value: item.route + '~#~' + item.route_desc,
            label: item.route + '-' + item.route_desc,
          }
        })
      )
    })
    if (type == '') handleShow()
    else setShowEdit2(true)
  }

  const getroutedata = async (salesorg: any) => {
    await getRoute(salesorg).then((res) => {
      setFullRoute(
        res.data.data.map((item: any) => {
          return {
            value: item.route + ',' + item.route_desc,
            label: item.route + '-' + item.route_desc,
          }
        })
      )
    })
  }

  const [numberURL, setNumberURL] = useState([])
  const [findesc, setFindesc] = useState('')
  const [finext, setfinext] = useState('')
  // const [isempty, setIsempty] = useState(false)

  const paginateNumber = async (number: any) => {
    const res = await axios.get(
      `${number}&customer_code=${custCode}&status=5&sales_org_code=${salesorg}&incoterm_id=&incoterm2_id=&findoc_desc=${findesc}&num_findoc=${finext}&currency=${currency}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setAllFindoc(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getFindocDataTableSearch(custCode, salesorg, '', '', findesc, finext, currency).then(
        (res: any) => {
          setAllFindoc(res.data.data.data)
          setNumberURL(res.data.data.links)
        }
      )
    }, 1000)

    return () => clearTimeout(getData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [findesc, finext])

  // console.log(allFindoc)

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const [quantityEdit, setQuantityEdit] = useState<any>()
  const [plantEdit, setPlantEdit] = useState<any>('')
  const [plantDescEdit, setPlantDescEdit] = useState<any>('')
  const [slocEdit, setSlocEdit] = useState<any>('')
  const [slocDescriptionEdit, setSlocDescriptionEdit] = useState<any>('')
  const [priceEdit, setPriceEdit] = useState<any>('')
  const [idEdit, setIdEdit] = useState<any>('')
  const [loadingModal, setLoadingModal] = useState(false)

  const handleEditSoItem = (
    quantity: any,
    plant: any,
    plantDesc: any,
    sloc: any,
    slocDescription: any,
    price: any,
    id: any
  ) => {
    handleShowEdit()
    setLoadingModal(true)
    setQuantityEdit(quantity)
    setPlantEdit(plant)
    setPlantDescEdit(plantDesc)
    setSlocEdit(sloc)
    setSlocDescriptionEdit(slocDescription)
    setPriceEdit(price)
    setIdEdit(id)
    setLoadingModal(false)
  }

  const submitEdit = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/so-item/${idEdit}`,
        {
          quantity: quantityEdit,
          plant: plantEdit,
          plant_desc: plantDescEdit,
          sloc: slocEdit,
          sloc_description: slocDescriptionEdit,
          price: priceEdit,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res) => {
        setBtnLoading(false)
        swal({
          title: `${t('Data Updated Successfully')}`,
          icon: 'success',
        }).then(() => {
          handleCloseEdit()
          navigate('/management/so')
        })
      })
      .catch((err) => {
        swal({
          title: `${t(err.response.data.message.message)}`,
          icon: 'error',
        })
      })
  }

  const [totalafterppn, setTotalAfterPPN] = useState<any>(0)

  useEffect(() => {
    if (priceBefore + totalPriceProductBefore >= 10000000) {
      setTotalAfterPPN(
        priceAfter +
          totalPriceProductAfter -
          ((priceBefore + totalPriceProductBefore) * parseFloat(pph22)) / 100
      )
    } else {
      if (idSector != 3) setTotalAfterPPN(parseInt(priceAfter) + parseInt(totalPriceProductAfter))
      else setTotalAfterPPN(parseFloat(priceAfter) + parseFloat(totalPriceProductAfter))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceBefore, totalPriceProductBefore])

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function convertDatePicker(date: any) {
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = String(date.getFullYear())
    return yyyy + '-' + mm + '-' + dd
  }

  const editAdditionalText = async () => {
    setBtnLoading(true)
    const payload = {
      customer_pic_name: custPICName ? custPICName : '',
      customer_pic_position: custPICPosition ? custPICPosition : '',
      financial_assigner_name: namaPenandatanganFinance || '',
      financial_assigner_position: posisiPenandatanganFinance || '',
      sailing_date: sailingDate ? sailingDate : '',
      port_of_loading: portLoading ? portLoading : '',
      additional_text_bast: textBAST ? textBAST : '',
      sales_division: salesDivision ? salesDivision : '',
      pic_sales_division: picSalesDivision ? picSalesDivision : '',
      terms_and_conditions: TOS ? TOS : '',
      terms_and_conditions_en: TOSEn ? TOSEn : '',
      terms_and_conditions_si: TOSsi ? TOSsi : '',
      terms_and_conditions_si_en: TOSsiEn ? TOSsiEn : '',
      customer_attn: attn ? attn : '',
      customer_attn_en: attnEn ? attnEn : '',
      text_penutup: penutup ? penutup : '',
      text_penutup_en: penutupEn ? penutupEn : '',
      keterangan: textKeterangan ? textKeterangan : '',
      keterangan_en: textKeteranganEn ? textKeteranganEn : '',
      referensi: referensi ? referensi : '',
      referensi_en: referensiEn ? referensiEn : '',
      tanggal_shipping_instruction: shippingInstruction ? shippingInstruction : '',
      invoice_notes: invoice ? invoice : '',
      invoice_notes_en: invoiceEn ? invoiceEn : '',
      eta_moda_angkut: ETA ? ETA : '',
      no_izin_export: noExport ? noExport : '',
      moda_angkut_name: trans ? trans : '',
      moda_angkut_type: transType ? transType : '',
      moda_angkut_type_en: transType2 ? transType2 : '',
      hydro_static_table: hydro ? hydro : '',
      assigner_name: assinger || '',
      assigner_position: position || '',
      port_of_discharge: pot || '',
      country_destination: country,
      province: provinsiTujuan,
      province_desc: provinsiTujuan2,
    }
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
    }).then(async (accept) => {
      if (accept) {
        await updateAdditionalText(soID, payload).then((res) => {
          setBtnLoading(false)
          swal({
            title: `${t('Data Updated Successfully')}`,
            icon: 'success',
          })
            .then(() => {
              navigate('/management/so')
            })
            .catch((err) => {
              swal({
                title: `${t(err.response.data.message.message)}`,
                icon: 'error',
              }).then(() => {})
            })
        })
      }
    })
    setBtnLoading(false)
  }

  const [letterData, setletterData] = useState<any>({})
  const [typeTransport, setTypeTransport] = useState(null)
  const [typeTransportEn, setTypeTransportEn] = useState(null)

  const handleShowPreview = async () => {
    let temp: any[] = []
    let tempquantum: any[] = []
    SODetail.forEach((element) => {
      temp.push(element.order_sub_detail)
      tempquantum.push({kuantum: element.quantity, index: 0})
    })
    if (addedProduct.length > 0) {
      addedProduct.forEach((element) => {
        temp.push(element)
        tempquantum.push({kuantum: element.quantity, index: 0})
      })
    }
    const tempaccessdata = JSON.parse(localStorage.getItem('accesses')!)
    let tempsales = ''
    let tempConfig = ''
    let tempTanggal = pickupDate
    if (salesorg != null && salesorg != undefined) tempsales = salesorg
    else tempsales = ''

    if(idSector == 2){
      try{
        await getBatasTanggalLetter(totalquant + totalQuantumProduct, tempsales, i18next.language, idSector).then(
          (res) => {
            tempTanggal = res.data.data
          }
        )
      }catch(e){
        console.log(e)
      }
    }
    await getConfigLetter(tempsales, 'sales-order').then((res) => {
      if (language === 'en') tempConfig = res.data.data.english?.content
      else tempConfig = res.data.data.indonesia?.content
      

      
      setletterData({
        lang: i18next.language,
        customer: customerTitle ? customerTitle + ' ' + customerName : customerName,
        configletter: tempConfig,
        address: customerAddress ? customerAddress : '',
        customerAddress: customerPreview || '',
        customerAttn: i18next.language == 'id' ? attn : (attnEn || (attn || '')),
        shippingTolerance_so: orderItems,
        namaAnper: roleUser == 'salesAnper' ? (tempaccessdata.name ? tempaccessdata.name : '') : '',
        subItem: temp ? temp : '',
        payloadQuantum: tempquantum,
        typeTransport: i18next.language === 'en' ? typeTransportEn  : typeTransport,
        transport: trans ? trans : '',
        etaTransport: ETA ? dateformat(ETA) : '',
        port: pot ? pot : '',
        portLoading: portLoading ? portLoading : '',
        sektor: idSector ? idSector : '',
        kontrakNum: SAPNum ? SAPNum : '',
        sailing: sailingDate ? dateformat(sailingDate) : '',
        bast: i18next.language == 'id' ? textBAST : (textBASTEn || (textBAST || '')),
        sales: salesDivision ? salesDivision : '',
        picSales: picSalesDivision ? picSalesDivision : '',
        term: i18next.language == 'id' ? TOS : (TOSEn || (TOS || '')),
        termSi: i18next.language == 'id' ? TOSsi : (TOSsiEn || (TOSsi || '')),
        ref: i18next.language == 'id' ? referensi : (referensiEn || (referensi || '')),
        tanggalShip: shippingInstruction ? dateformat(shippingInstruction) : '',
        inv: i18next.language == 'id' ? invoice : (invoiceEn || (invoice || '')),
        textPenutup: i18next.language == 'id' ? penutup : (penutupEn || (penutup || '')),
        keterangan: i18next.language == 'id' ? textKeterangan : (textKeteranganEn || (textKeterangan || '')),
        footerCon: '',
        contractNumber: SAPNum ? SAPNum : '',
        signername: assinger ? assinger : '',
        singerposition: position ? position : '',
        cusName: custPICName ? custPICName : '',
        cusPosition: custPICPosition ? custPICPosition : '',
        financial_assigner_name: namaPenandatanganFinance || '',
        financial_assigner_position: posisiPenandatanganFinance || '',
        custgroup: custGroup ? custGroup : '',
        batasTanggal: tempTanggal,
        salesorgname: idSector != 2 ? (salesorgname ?? '') : "PT PUPUK INDONESIA (PERSERO)",
        sotype: 'detail',
        imgHeader: imgHeader ? imgHeader?.url_file : '',
        imgFooter: imgFooter ? imgFooter?.url_file : '',
        sapNumber: detailSO?.sap_number,
        approvedDate: detailSO?.create_so_sap_date,
      })
      // console.log(letterData, 'infunction')
      setShowLetter(true)
    })
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const loadSigningConfig = async () => {
    if(!signingPayload.province_id || !signingPayload.city_id) return
    setBtnLoading(true)

    const res = await getForModule(signingPayload)
      .then((res: any) => {
        const resp = res.data.data
        if (resp) {
          if (!namaPenandatanganFinance) {
            setNamaPenandatanganFinance(resp.signer_name)
          }
          if (!posisiPenandatanganFinance) {
            setPosisiPenandatanganFinance(resp.signer_position)
          }
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const addNewSoItem = (new_item: any) => {

    const items = [... SODetail, new_item]

    setLeftoverArray(leftoverArray.map((item: any) => {
      return item.order_sub_detail_id == new_item.id ? {
        ... item,
        left_over_quantum: (item.left_over_quantum - new_item.quantity),
        left_over_quantum_no_st: (item.left_over_quantum_no_st - new_item.quantity),
      } : item
    }))

    setSODetail(items)
    appDispatch(setOrderItems(items))

    const _signingConfig = signingPayload
    _signingConfig.total_quantum = items.reduce((prev: number, curr: any) => {
      if (curr.product_type != '8105') {
        return prev + curr.quantity;
      } else {
        return prev
      }
    }, 0)
    
    setSigningPaylod(_signingConfig)
    loadSigningConfig()

    setShowAddSO(false)
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page revise so')}</PageTitle>
      <div className='card'>
        {isLoadingPage ? (
          <div className='p-5'>
            <SkeletonPageDetail />
          </div>
        ) : (
              <>
                <div className='card-body'>
                  <Row>
                    <Col md={6}>
                      {SIP_ID == 0 || SIP_ID == null ? (
                        <>
                          <Row>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>{t('kontrak-nomor')} SAP</p>
                            </Col>
                            <Col md={7}>
                              <Form.Control
                                className='w-100'
                                aria-label='Default select example'
                                value={SAPNum}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>{t('SIP ID')}</p>
                            </Col>
                            <Col md={7}>
                              <Form.Control
                                className='w-100'
                                aria-label='Default select example'
                                value={String(SIP_ID)}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </>
                      )}

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerCode} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            Incoterm
                            {/* <span className='text-danger'>{isApprovalAnper ? '*' : ''}</span> */}
                          </p>
                        </Col>
                        <Col md={7}>
                          <Select
                            id='incoterm1'
                            placeholder='Incoterm 1'
                            key={custCode}
                            defaultValue={fullIncoterm.find((item: any) => item.label === incotermIdDesc)}
                            onChange={(e: any) => {
                              separateValue2(setIncotermId, e.value)
                              clearfindoc()
                            }}
                            options={fullIncoterm}
                          />
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('sub-order-negara')}</p>
                        </Col>
                        <Col md={7}>
                          {isApprovalAnper ? (
                            <Form.Select
                              aria-label='Default select example'
                              size='sm'
                              placeholder={t('sub-order-negara')}
                              onChange={(e: any) => setCountry(e.target.value)}
                            >
                              <option selected>{t('Pilih-country')}</option>
                              {Country.dataCountry.map((item: any, index: number) => {
                                return (
                                  <option key={item?.name ?? index} value={item.name}>
                                    {item.name}
                                  </option>
                                )
                              })}
                            </Form.Select>
                          ) : anperEdit ? (
                            <Form.Select
                              aria-label='Default select example'
                              size='sm'
                              placeholder={t('sub-order-negara')}
                              onChange={(e: any) => {
                                setProvinsiTujuan('')
                                setProvinsiTujuan2('')
                                setCountry(e.target.value)
                              }}
                            >
                              {Country.dataCountry?.map((item: any) => (
                                <>
                                  {item?.name == country ? (
                                    <option selected value={item?.name}>
                                      {item?.name}
                                    </option>
                                  ) : (
                                    <option value={item?.name}>{item?.name}</option>
                                  )}
                                </>
                              ))}
                            </Form.Select>
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={country}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            Sales Office
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {isApprovalAnper ? (
                            <Select
                              id='provinsi'
                              placeholder={'Sales office'}
                              onChange={(e: any) => setProvince(e?.value)}
                              options={fullProvince}
                            />
                          ) : anperEdit ? (
                            <Select
                              id='provinsi'
                              placeholder={'Sales office'}
                              key={String(loading) + fullProvince}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label == province2)
                                ]
                              }
                              onChange={(e: any) => setProvince(e?.value)}
                              options={fullProvince}
                            />
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={province2}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      {idSector != 2 ? (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>
                              {t('Customer Account Group')}
                              {/* <span className='text-danger'>{isApprovalAnper || anperEdit ? '*' : ''}</span> */}
                            </p>
                          </Col>
                          <Col md={7}>
                            {isApprovalAnper ? (
                              <Select
                                id=''
                                placeholder={t('Customer Account Group')}
                                key={custCode}
                                onChange={(e: any) => setCustGroup(e?.value)}
                                options={fullCust}
                                value={
                                  fullCust[
                                    fullCust.findIndex(
                                      (item: any) =>
                                        item.value === detailSO?.customer_account_group_detail?.code
                                    )
                                  ]
                                }
                              />
                            ) : anperEdit ? (
                              <Select
                                id=''
                                placeholder={t('Customer Account Group')}
                                key={custCode}
                                value={
                                  fullCust[
                                    fullCust.findIndex(
                                      (item: any) =>
                                        item.value === detailSO?.customer_account_group_detail?.code
                                    )
                                  ]
                                }
                                onChange={(e: any) => setCustGroup(e?.value)}
                                options={fullCust}
                              />
                            ) : (
                              <Form.Control id='' value={custGroup2} disabled size='sm' />
                            )}
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            {t('so-jenisAngkut')}
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(anperEdit || isApprovalAnper) ? (
                            <Form.Select
                              aria-label='Default select example'
                              size='sm'
                              id='ttrans'
                              placeholder={t('so-jenisAngkut')}
                              onChange={(e: any) =>
                                separator2(e.target.value, setTransType, setTransType2)
                              }
                            >
                              <option selected value='~#~'>
                                {t('pilih')} {t('so-jenisAngkut')}
                              </option>
                              {fullTransport.map((item: any) => {
                                return (
                                  <>
                                    {item.name_id + ',' + item.name_en ==
                                    transType + ',' + transType2 ? (
                                      <option selected value={item.name_id + '~#~' + item.name_en}>
                                        {i18next.language == 'en' ? item.name_en : item.name_id}
                                      </option>
                                    ) : (
                                      <option value={item.name_id + '~#~' + item.name_en}>
                                        {i18next.language == 'en' ? item.name_en : item.name_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              defaultValue={i18next.language == 'en' ? transType2 : transType}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            {t('Assigner Name')}
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                            <Form.Control
                              placeholder={t('Assigner Name')}
                              size='sm'
                              value={assinger}
                              onChange={(e: any) => setAssigner(e.target.value)}
                            />
                          ) : (
                            <Form.Control size='sm' defaultValue={assinger} disabled />
                          )}
                        </Col>
                      </Row>

                      {transType != 'Truk' && (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('so-rencana')}</p>
                          </Col>
                          <Col md={7}>
                            {(isApprovalAnper || anperEdit) ? (
                              <Form.Control
                                type='text'
                                placeholder={t('so-rencana')}
                                onChange={(e: any) => setStowage(e.target.value)}
                                defaultValue={detailSO?.stowage_plan}
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                defaultValue={t(stowage)}
                                disabled
                              />
                            )}
                          </Col>
                        </Row>
                      )}

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            {t('so-jenisP')}
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                             <Form.Select
                              aria-label='Default select example'
                              size='sm'
                              key={fullPayment}
                              onChange={(e: any) => {
                                const temp = e.target.value.split(',')
                                setPay(temp[0])
                                setPaySAP(temp[1])
                                setFindoc('')
                                if (temp[1] == 'P') {
                                  hitTOP()
                                }
                              }}
                            >
                              <option selected value=''>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment?.map((item: any) => (
                                <>
                                  {item?.code == pay ? (
                                    <option selected value={item.code + ',' + item.code_sap}>
                                      {idSector == 3 ? item.payment_desc : item.payment_desc_id}
                                    </option>
                                  ) : (
                                    <option value={item.code + ',' + item.code_sap}>
                                      {idSector == 3 ? item.payment_desc : item.payment_desc_id}
                                    </option>
                                  )}
                                </>
                              ))}
                            </Form.Select>
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={t(pay2)}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      {paySAP == 'M' || paySAP == 'DF' ? (
                        <>
                          <Row className='mt-3'>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>Findoc</p>
                            </Col>
                            <Col md={7}>
                              {(isApprovalAnper || anperEdit) ? (
                                 <>
                                 <div className='d-flex align-items-center' key={selectedFindoc}>
                                   <Form.Control
                                     disabled
                                     defaultValue={selectedFindoc}
                                     placeholder='Findoc'
                                     size='sm'
                                   />
                                   <Button
                                     variant='primary'
                                     className='ms-1 px-2'
                                     onClick={() => handlebrowsefindoc()}
                                   >
                                     {t('Browse')}
                                   </Button>
                                 </div>
                               </>
                              ) : (
                                <>
                                  <div className='d-flex align-items-cem' key={findoc2}>
                                    <Form.Control
                                      aria-label='Default select example'
                                      size='sm'
                                      defaultValue={findoc2}
                                      disabled
                                    />
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 px-2'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('unduh')}
                                      onClick={() =>
                                        handleDownloadAttachment(
                                          findocLoc
                                        )
                                      }
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/arrow-down-square-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </div>
                                </>
                              )}

                              <Modal
                                show={showBrowseFindoc}
                                onHide={() => setShowBrowseFindoc(false)}
                                centeredbackdrop='static'
                                keyboard={false}
                                size='lg'
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>{t('Browse')}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className='table-responsive bdr'>
                                    <Row className='mb-4'>
                                      <Col md={6}>
                                        <Form.Label>{t('Findoc Desc')}</Form.Label>
                                        <Form.Control
                                          aria-label='Default select example'
                                          id='searchpo'
                                          placeholder={t('cari') + ' ' + t('Findoc Desc')}
                                          size='sm'
                                          onChange={(e: any) => setFindesc(e.target.value)}
                                        />
                                      </Col>
                                      <Col md={6}>
                                        <Form.Label>{t('Ext Findoc Number')}</Form.Label>
                                        <Form.Control
                                          aria-label='Default select example'
                                          id='searchpo'
                                          placeholder={t('cari') + ' ' + t('Ext Findoc Number')}
                                          size='sm'
                                          onChange={(e: any) => setfinext(e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                    <table className='table table-striped table-hover'>
                                      <thead>
                                        <tr>
                                          <th className='text-center'></th>
                                          <th className='text-center'>{t('Findoc Desc')}</th>
                                          <th className='text-center'>{t('Ext Findoc Number')}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allFindoc.map((item: any, index: any) => {
                                          return (
                                            <tr key={item?.id ?? index}>
                                              <td className='text-center'>
                                                <Form.Check
                                                  reverse
                                                  type='checkbox'
                                                  id={
                                                    item.id +
                                                    '~#~' +
                                                    item.top +
                                                    '~#~' +
                                                    item.top +
                                                    '~#~' +
                                                    item.num_findoc
                                                  }
                                                  onChange={(e: any) => {
                                                    separator(
                                                      e.target.id,
                                                      setFindoc,
                                                      setTOP,
                                                      setTOP2,
                                                      setSelectedFindoc
                                                    )
                                                    setShowBrowseFindoc(false)
                                                  }}
                                                />
                                              </td>
                                              <td className='text-center'>{item.findoc_desc}</td>
                                              <td className='text-center'>{item.num_findoc}</td>
                                            </tr>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                    <div className='my-5'>
                                      <Pagination paginate={paginateNumber} test={numberURL} />
                                    </div>
                                  </div>
                                </Modal.Body>
                              </Modal>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}

                      {paySAP == 'M' || paySAP == 'DF' ? (
                        <>
                          <Row className='mt-3'>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>TOP</p>
                            </Col>
                            <Col md={7}>
                              <Form.Select aria-label='Default select example' size='sm' disabled>
                                <option selected disabled hidden>
                                  {isApprovalAnper || anperEdit ? condTOP(top2) : TOPDesc2}
                                </option>
                              </Form.Select>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}

                      {paySAP == 'P' && (
                        <>
                          <Row className='mt-3'>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>TOP</p>
                            </Col>
                            <Col md={7}>
                              {(isApprovalAnper || anperEdit) ? (
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  placeholder='TOP'
                                  onChange={(e: any) => setTOP(e.target.value)}
                                >
                                  <option selected value=''>
                                    {t('pilih')} TOP
                                  </option>
                                  {fullTOP.map((item: any) => {
                                    return (
                                      <>
                                        <option value={item.code}>{item.top_desc}</option>
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              ) : (
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  disabled
                                  onChange={(e: any) => setTOP(e.target.value)}
                                >
                                  <option selected value={top}>
                                    {TOPDesc2}
                                  </option>
                                  {fullTOP.map((item: any) => {
                                    return (
                                      <>
                                        <option value={item.code}>{item.top_desc}</option>
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      <Row className='mt-2' hidden={anperEdit ? false : true}>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col md={7}>
                          <div className='d-flex' style={{width: '100%'}}>
                            <Form.Control
                              type='text'
                              size='sm'
                              className='w-100'
                              disabled
                              placeholder={t('Ship To')}
                              // placeholder={'Search' + ' ' + t('Customer')}
                              value={customer}
                              style={{width: '70%'}}
                            />
                            <Button
                              className='btn btn-primary d-flex justify-contletterent-center align-items-center ms-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('telusuri')}
                              onClick={() => handleCustomer()}
                            >
                              <KTSVG
                                path='/media/icons/duotune/browse.svg'
                                className='svg-icon-3 ms-2'
                              />
                            </Button>
                          </div>
                        </Col>
                      </Row>

                      {/* <Row className='mt-3' hidden={shipCust ? false : true}>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col md={7} className='d-flex justify-content-end'>
                        <Form.Check
                          reverse
                          className='mt-2 mb-2'
                          type='checkbox'
                          id='ckbox-ship'
                          disabled
                          checked={true}
                        />
                        </Col>
                        </Row> */}

                      <Row className='mt-2' hidden={shipCust && anperEdit == false ? false : true}>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col md={7}>
                          <div className='d-flex' style={{width: '100%'}}>
                            <Form.Control
                              type='text'
                              size='sm'
                              className='w-100'
                              placeholder={t('Ship To')}
                              disabled
                              value={shipCust}
                              style={{width: '70%'}}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    
                    <Col md={6}>
                      <Row>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Address')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            as='textarea'
                            value={customerAddress}
                            disabled
                            size='sm'
                            style={{maxHeight: '40px', padding: '0.3rem 0.775rem'}}
                          />
                        </Col>
                      </Row>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerName} disabled size='sm' />
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            Incoterm 2
                            {/* <span className='text-danger'>{isApprovalAnper ? '*' : ''}</span> */}
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              defaultValue={incotermId2}
                              placeholder='Incoterm 2'
                              onChange={(e: any) => {
                                setIncotermId2(e.target.value)
                                clearfindoc()
                              }}
                            />
                          )  : (
                            <Form.Control
                              aria-label='Default select example'
                              disabled
                              size='sm'
                              defaultValue={incotermId2}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                        </Col>
                        <Col md={7}>
                          {(anperEdit || isApprovalAnper) ? (
                            <Select
                              id='provinsi'
                              placeholder={t('pilih')}
                              onChange={(e: any) =>
                                separator2(e.value, setProvinsiTujuan, setProvinsiTujuan2)
                              }
                              value={
                                fullProvince2[
                                  fullProvince2.findIndex(
                                    (item: any) => item.label == provinsiTujuan2
                                  )
                                ]
                              }
                              key={fullProvince2 + country + provinsiTujuan2}
                              options={idSector != 3 && country == 'Indonesia' ? fullProvince2 : []}
                            />
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              disabled
                              size='sm'
                              value={provinsiTujuan2}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            Sales Group
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                            <Select
                              onChange={(e: any) => setCity(e?.value)}
                              placeholder={'Sales Group'}
                              key={String(loading) + fullCity}
                              value={
                                fullCity[fullCity.findIndex((item: any) => item.label === city2)]
                              }
                              options={fullCity}
                            />
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={city2}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      {idSector != 2 ? (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>
                              {t('Account Assignment group')}
                              {/* <span className='text-danger'>{isApprovalAnper || anperEdit ? '*' : ''}</span> */}
                            </p>
                          </Col>
                          <Col md={7}>
                            {anperEdit ? (
                              <Select
                                id=''
                                key={custCode + fullAssign + custAssign}
                                placeholder={t('Account Assignment group')}
                                defaultValue={
                                  fullAssign[
                                    fullAssign.findIndex((item: any) => item.value === custAssign)
                                  ]
                                }
                                onChange={(e: any) => setCustAssing(e?.value)}
                                options={fullAssign}
                              />
                            ) : (
                              <Form.Control id='' value={custAssign2} disabled size='sm' />
                            )}
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            {t('so-namaAngkut')}
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                              <Form.Control
                                placeholder={t('so-namaAngkut')}
                                aria-label='Default select example'
                                size='sm'
                                onChange={(e: any) => setTrans(e.target.value)}
                                value={trans}
                              />
                           ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              defaultValue={trans2}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>
                            {t('Assigner Position')}
                            <span className='text-danger'>
                              {isApprovalAnper || anperEdit ? '*' : ''}
                            </span>
                          </p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                            <Form.Control
                              placeholder={t('Position')}
                              size='sm'
                              value={position}
                              onChange={(e: any) => setPosition(e.target.value)}
                            />
                          ) : (
                            <Form.Control size='sm' defaultValue={position} disabled />
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Tujuan')}</p>
                        </Col>
                        <Col md={7}>
                          {(isApprovalAnper || anperEdit) ? (
                            <Form.Control
                              placeholder={t('Tujuan')}
                              size='sm'
                              onChange={(e: any) => setPot(e.target.value)}
                              value={pot}
                            />
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              disabled
                              defaultValue={pot}
                            />
                          )}
                        </Col>
                      </Row>

                      {transType === 'Kapal' ? (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('so-hydro')}</p>
                          </Col>
                          <Col md={7}>
                            {hydro2 == null || hydro == '' ? (
                              <Col md={7}>
                                <Button
                                  variant='primary'
                                  id='btnupload1'
                                  onClick={() => {
                                    setUploadType('hydro')
                                    setShowUploadHydro(true)
                                  }}
                                >
                                  {t('order-lampiranUpload')}
                                </Button>
                                <Modal
                                  show={showUploadHydro}
                                  onHide={() => {
                                    setUploadType('')
                                    setShowUploadHydro(false)
                                  }}
                                  backdrop='static'
                                  keyboard={false}
                                  centered
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>
                                      {uploadType == 'hydro' ? t('so-hydro') : t('so-ship')}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row>
                                      <Col sm={3} className='mt-4'>
                                        <h6>{t('order-fileUnggah')}</h6>
                                      </Col>
                                      <Col sm={9}>
                                        <InputFile
                                            setFileName={(value: string) => {
                                              if (uploadType == 'hydro'){
                                                setFilesHydroName(value)
                                              }else{
                                                setFilesShipName(value)
                                              }
                                            }}
                                            setFiles={(value: any) => {
                                              if (uploadType == 'hydro'){
                                                setFilesHydro(value)
                                              }else{
                                                setFilesShip(value)
                                              }
                                            }}
                                        />
                                      </Col>
                                      <Button
                                        variant='primary'
                                        className='w-100 mt-5'
                                        onClick={() => closeupload()}
                                      >
                                        {t('order-kirim')}
                                      </Button>
                                    </Row>
                                  </Modal.Body>
                                </Modal>
                              </Col>
                            ) : (
                              <Col md={7}>
                                <Button
                                  variant='primary'
                                  id='btnupload'
                                  onClick={() =>
                                    handleDownloadAttachment(hydro2)
                                  }
                                >
                                  {t('unduh')}
                                </Button>
                              </Col>
                            )}
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}

                      {transType === 'Kapal' && (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('so-ship')}</p>
                          </Col>
                          <Col md={7}>
                            {ship == '' || ship == null ? (
                              <Button
                                variant='primary'
                                id='btnupload2'
                                onClick={() => {
                                  setUploadType('ship')
                                  setShowUploadHydro(true)
                                }}
                              >
                                {t('order-lampiranUpload')}
                              </Button>
                            ) : (
                              <Button
                                variant='primary'
                                id='btnupload2'
                                onClick={() =>
                                  handleDownloadAttachment(ship)
                                }
                              >
                                {t('unduh')}
                              </Button>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>

                    <Modal
                      show={showCustomer}
                      onHide={() => setShowCustomer(false)}
                      centered
                      backdrop='static'
                      keyboard={false}
                      size='lg'
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('Browse')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className='table-responsive bdr'>
                          <Row className='mb-4'>
                            <Col md={6}>
                              <Form.Label>{t('Customer Code')}</Form.Label>
                              <Form.Control
                                aria-label='Default select example'
                                id='searchpo'
                                placeholder={t('Search Customer Code')}
                                size='sm'
                                onChange={(e: any) => setCustName(e.target.value)}
                              />
                            </Col>
                            <Col md={6}>
                              <Form.Label>{t('Customer Name')}</Form.Label>
                              <Form.Control
                                aria-label='Default select example'
                                id='searchpo'
                                placeholder={t('Search Customer Name')}
                                size='sm'
                                onChange={(e: any) => setCustNum(e.target.value)}
                              />
                            </Col>
                          </Row>
                          <table className='table table-striped table-hover'>
                            <thead>
                              <tr>
                                <th className='text-center'></th>
                                <th className='text-center'>{t('Customer Code')}</th>
                                <th className='text-center'>{t('Customer Name')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {fullCustomer.map((item: any, index: any) => {
                                return (
                                  <tr key={item?.name ?? index}>
                                    <td className='text-center'>
                                      <Form.Check
                                        reverse
                                        type='checkbox'
                                        id={item?.customer_code}
                                        onChange={(e: any) => {
                                          setCustomer(
                                            item.title == null
                                              ? item.name
                                              : item.title + ' ' + item.name
                                          )
                                          setCustomerID(item.customer_code)
                                          setShowCustomer(false)
                                        }}
                                      />
                                    </td>
                                    <td className='text-center'>{item.customer_code}</td>
                                    <td className='text-center'>{item.name}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                          <div className='my-5'>
                            <Pagination paginate={paginateNumber2} test={numberURL2} />
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </Row>

                  <div className='my-5 d-flex'>
                    {
                      (
                        contractItems.length > 0 && 
                        leftoverArray.reduce((acc: number, item: any) => acc + item.left_over_quantum, 0) > 0
                      ) && (
                      <Button
                        className='btn btn-primary me-2'
                        onClick={() => {
                          setShowAddSO(true)
                        }}
                        >
                          {t('+tambah') + ' SO'}
                        </Button>
                    )}
                    <Button
                      hidden={anperEdit == true ? false : true}
                      className='btn btn-primary me-2'
                      onClick={() => handleTambahProduct()}
                    >
                      {t('+tambah product')}
                    </Button>
                    <Button
                      className='btn btn-primary me-2'
                      hidden={
                        ((status == 6 ||
                          status == 9 ||
                          ((status == 0 || status == 1) && idSector != 2)) &&
                          roleUser == 'salesAnper') ||
                        anperEdit
                          ? false
                          : true
                      }
                      onClick={() => setShowAdditional(true)}
                    >
                      {t('addtional')} {t('text')}
                    </Button>

                    <Modal
                      show={showAdditional}
                      onHide={() => setShowAdditional(false)}
                      centered
                      backdrop='static'
                      keyboard={false}
                      scrollable
                      size='lg'
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {t('addtional')} {t('text')}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <div className="d-flex justify-content-end mb-3">
                    <div style={{maxWidth: 140}} className='btn-lang d-flex'>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'id' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('id')}
                      >
                        <h6 className='ms-1'>Ind</h6>
                      </button>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'en' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('en')}
                      >
                        <h6 className='ms-1'>Eng</h6>
                      </button>
                    </div>
                  </div>


                  { addTextLanguage == 'id' && <div>
                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'customer pic name'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('customer pic name')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'customer pic name'}>
                            <Form.Control
                              className='mt-3'
                              as='textarea'
                              //maxLength={132}
                              aria-label='Default select example'
                              onChange={(e: any) => setCustPICName(e.target.value)}
                              placeholder={t('customer pic name')}
                              defaultValue={custPICName}
                            />
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic name', setCustPICName, custPICName_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'customer pic position'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('customer pic position')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'customer pic position'}>
                            <Form.Control
                              className='mt-3'
                              as='textarea'
                              //maxLength={132}
                              aria-label='Default select example'
                              onChange={(e: any) => setCustPICPosition(e.target.value)}
                              placeholder={t('customer pic position')}
                              defaultValue={custPICPosition}
                            />
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic position', setCustPICPosition, custPICPosition_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'nama penandatangan keuangan'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('nama penandatangan keuangan')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'nama penandatangan keuangan'}>
                            <Form.Control
                              className='mt-3'
                              as='textarea'
                              //maxLength={132}
                              aria-label='Default select example'
                              onChange={(e: any) => setNamaPenandatanganFinance(e.target.value)}
                              placeholder={t('nama penandatangan keuangan')}
                              defaultValue={namaPenandatanganFinance}
                            />
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'posisi penandatangan keuangan'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('posisi penandatangan keuangan')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'posisi penandatangan keuangan'}>
                            <Form.Control
                              className='mt-3'
                              as='textarea'
                              //maxLength={132}
                              aria-label='Default select example'
                              onChange={(e: any) => setPosisiPenandatanganFinance(e.target.value)}
                              placeholder={t('posisi penandatangan keuangan')}
                              defaultValue={posisiPenandatanganFinance}
                            />
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'sailing date'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('sailing date')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'sailing date'}>
                            {/* <DatePicker
                          className='form-control'
                          selected={sailingDate_}
                          onChange={(date: any) =>
                            handleSaveAdditionalText2(
                              'sailing date',
                              setSailingDate,
                              date,
                              setSailingDate_
                            )
                          }
                          dateFormat='yyyy/MM/dd'
                        /> */}
                            <Form.Control
                              className='mt-3'
                              type='date'
                              aria-label='Default select example'
                              onChange={(date) =>
                                handleSaveAdditionalText2(
                                  'sailing date',
                                  setSailingDate,
                                  date,
                                  setSailingDate_
                                )
                              }
                              placeholder={t('sailing date')}
                              defaultValue={sailingDate}
                            />
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('sailing date', setSailingDate, sailingDate_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'port of discharge'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('port of discharge')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'port of discharge'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setPortDischarge(e.target.value)}
                        placeholder={t('port of discharge')}
                        defaultValue={portDischarge}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of discharge', setPortDischarge, portDischarge)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'port of loading'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('port of loading')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'port of loading'}>
                            <RichText
                              containerClassName='mt-4'
                              content={portLoading}
                              onUpdate={({editor}) => setPortLoading(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of loading', setPortLoading, portLoading_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'additional text bast'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('additional text bast')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'additional text bast'}>
                            <RichText
                              containerClassName='mt-4'
                              content={textBAST}
                              onUpdate={({editor}) => setTextBAST(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'sales division'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('sales division')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'sales division'}>
                            <RichText
                              containerClassName='mt-4'
                              content={salesDivision}
                              onUpdate={({editor}) => setSalesDivision(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('sales division', setSalesDivision, salesDivision_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'pic sales division'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('pic sales division')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'pic sales division'}>
                            <RichText
                              containerClassName='mt-4'
                              content={picSalesDivision}
                              onUpdate={({editor}) => setPicSalesDivision(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('pic sales division', setPicSalesDivision, picSalesDivision_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'transportation media'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('transportation media')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'transportation media'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTransportMedia_(e.target.value)}
                        placeholder={t('transportation media')}
                        defaultValue={transportMedia}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media', setTransportMedia, transportMedia_)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'transportation media info'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('transportation media info')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'transportation media info'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTransportMediaInfo_(e.target.value)}
                        placeholder={t('transportation media info')}
                        defaultValue={transportMediaInfo}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media info', setTransportMediaInfo, transportMediaInfo_)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'term and condition'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('terms_and_conditions')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'term and condition'}>
                            <RichText
                              containerClassName='mt-4'
                              content={TOS}
                              onUpdate={({editor}) => setTOS(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'term and condition si'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('terms_and_conditions')} SI</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'term and condition si'}>
                            <RichText
                              containerClassName='mt-4'
                              content={TOSsi}
                              onUpdate={({editor}) => setTOSsi(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'customer attn'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('customer attn')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'customer attn'}>
                            <RichText
                              containerClassName='mt-4'
                              content={attn}
                              onUpdate={({editor}) => setAttn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'text penutup'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('text penutup')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'text penutup'}>
                            <RichText
                              containerClassName='mt-4'
                              content={penutup}
                              onUpdate={({editor}) => setPenutup(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'eta moda angkut'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('eta moda angkut')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'eta moda angkut'}>
                            <Form.Control
                              className='mt-3'
                              type='date'
                              aria-label='Default select example'
                              onChange={(date: any) =>
                                handleSaveAdditionalText2('eta moda angkut', setETA, date, setETA_)
                              }
                              placeholder={t('eta moda angkut')}
                              defaultValue={ETA}
                            />
                            {/* <DatePicker
                          className='form-control'
                          selected={ETA_}
                          onChange={(date: any) =>
                            handleSaveAdditionalText2('eta moda angkut', setETA, date, setETA_)
                          }
                          dateFormat='yyyy/MM/dd'
                        /> */}
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('eta moda angkut', setETA, ETA_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'keterangan'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('keterangan')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'keterangan'}>
                            <RichText
                              containerClassName='mt-4'
                              content={textKeterangan}
                              onUpdate={({editor}) => setTextKeterangan(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'referensi'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('referensi')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'referensi'}>
                            <RichText
                              containerClassName='mt-4'
                              content={referensi}
                              onUpdate={({editor}) => setReferensi(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'tanggal shipping instruction'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('tanggal shipping instruction')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'tanggal shipping instruction'}>
                            <Form.Control
                              className='mt-3'
                              type='date'
                              aria-label='Default select example'
                              onChange={(date: any) =>
                                handleSaveAdditionalText2(
                                  'tanggal shipping instruction',
                                  setShippingInstruction,
                                  date,
                                  setShippingInstruction_
                                )
                              }
                              placeholder={t('tanggal shipping instruction')}
                              defaultValue={shippingInstruction}
                            />
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('tanggal shipping instruction', setShippingInstruction, shippingInstruction_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'invoice note'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('invoice note')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'invoice note'}>
                            <RichText
                              containerClassName='mt-4'
                              content={invoice}
                              onUpdate={({editor}) => setInvoice(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'nomor export'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('nomorIzinExport')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'nomor export'}>
                            <RichText
                              containerClassName='mt-4'
                              content={noExport}
                              onUpdate={({editor}) => setNoExport(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                          </div> */}
                          </div>
                        </Form.Group>
                        <hr />
                  </div> }
                  { addTextLanguage == 'en' && <div>
                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'additional text bast'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('additional text bast')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'additional text bast'}>
                            <RichText
                              containerClassName='mt-4'
                              content={textBASTEn}
                              onUpdate={({editor}) => setTextBASTEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'term and condition'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('terms_and_conditions')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'term and condition'}>
                            <RichText
                              containerClassName='mt-4'
                              content={TOSEn}
                              onUpdate={({editor}) => setTOSEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'term and condition si'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('terms_and_conditions')} SI</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'term and condition si'}>
                            <RichText
                              containerClassName='mt-4'
                              content={TOSsiEn}
                              onUpdate={({editor}) => setTOSsiEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'customer attn'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('customer attn')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'customer attn'}>
                            <RichText
                              containerClassName='mt-4'
                              content={attnEn}
                              onUpdate={({editor}) => setAttnEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'text penutup'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('text penutup')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'text penutup'}>
                            <RichText
                              containerClassName='mt-4'
                              content={penutupEn}
                              onUpdate={({editor}) => setPenutupEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'keterangan'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('keterangan')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'keterangan'}>
                            <RichText
                              containerClassName='mt-4'
                              content={textKeteranganEn}
                              onUpdate={({editor}) => setTextKeteranganEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'referensi'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('referensi')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'referensi'}>
                            <RichText
                              containerClassName='mt-4'
                              content={referensiEn}
                              onUpdate={({editor}) => setReferensiEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />

                        <Form.Group className='mb-3' controlId='formBasicEmail'>
                          <div className='d-flex align-items-center'>
                            <button
                              className='a btn btn-primary w-100'
                              data-target={'target' + 'invoice note'}
                              onClick={(e: any) => handleOpenn(e)}
                            >
                              <div className='text-light'>{t('invoice note')}</div>
                            </button>
                          </div>
                          <div className='fold' id={'target' + 'invoice note'}>
                            <RichText
                              containerClassName='mt-4'
                              content={invoiceEn}
                              onUpdate={({editor}) => setInvoiceEn(editor.getHTML())}
                            >
                              <div style={{display: 'none'}}>&nbsp;</div>
                            </RichText>
                            {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                        </div> */}
                          </div>
                        </Form.Group>
                        <hr />
                  </div> }
                        

                        {/* <div className='d-flex justify-content-end mt-5' >

                    </div> */}
                      </Modal.Body>
                    </Modal>

                    <div>
                      <Button
                        onClick={() => {
                          handleShowPreview()
                        }}
                        className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('preview')}
                      >
                        {t('preview')}
                      </Button>
                    </div>

                    <Modal
                      show={showLetter}
                      onHide={() => setShowLetter(false)}
                      size='xl'
                      backdrop='static'
                      keyboard={false}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('preview')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body key={letterData}>
                        <ViewLetter data={letterData} type='so' />
                      </Modal.Body>
                    </Modal>

                    <Button
                      variant='primary'
                      className="ms-2"
                      onClick={() => {
                        setShowUpload(true)
                        setSubOrderID(SOID || '')
                        setAttachmentType('sales-order')
                        ambilAttachment(SOID, 'sales-order')
                      }}
                    >
                      {t('order-lampiran')}
                    </Button>
                  </div>
                  <div className='table-responsive bdr'>
                    {/* Table Head */}
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')}</th>
                              <th>{t('order-aksi')}</th>
                              <th>{t('Sektor')}</th>
                              <th>{t('kontrak-jenis')}</th>
                              <th>{t('Product Code')}</th>
                              <th>{t('kontrak-nama')}</th>
                              <th>{t('kontrak-spek')}</th>
                              <th>{t('kontrak-kuantum')}</th>
                              {/* {idSector != 2 ? (<th>{t("Shipping Tolerance")}</th>) : ''} */}
                              <th>{t('Price')}</th>
                              <th>{t('kontrak-hargaPPN')}</th>
                              <th>PPN</th>
                              <th>{t('kontrak-hargaSPPN')}</th>
                              <th>{t('Plant')}</th>
                              <th>{t('Route')}</th>
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {SODetail.map((item: any, _index: any) => (
                              <tr key={item?.id ?? _index}>
                                <td>
                                  <div>{item.order_sub_detail?.produsen?.name}</div>
                                </td>
                                {
                                  // sector retail
                                  item.order_sub_detail?.sector?.id == 2 ? (
                                    // after approved by salesAnper
                                    incotermIdDesc && incotermId2 && !isApprovalAnper ? (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              incotermId2
                                                ? incotermIdDesc + '-' + incotermId2
                                                : incotermIdDesc
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    ) : // before approved by salesAnper
                                    item.order_sub_detail?.incoterm2 == null ? (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item.incoterm2_id
                                                ? item.incoterm1?.code + '-' + item.incoterm2_id
                                                : item.incoterm1?.code
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    ) : (
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item.incoterm2?.code
                                                ? item.incoterm1?.code + '-' + item.incoterm2?.code
                                                : item.incoterm1?.code
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                    )
                                  ) : (
                                    // except sector retail
                                    <>
                                      {anperEdit ? (
                                        item.incoterm2 == null ? (
                                          <td>
                                            <div>
                                              <PopoverText
                                                content={
                                                  item.incoterm2_id
                                                    ? item.incoterm1?.code + '-' + item.incoterm2_id
                                                    : item.incoterm1?.code + '-' + item.incoterm2
                                                }
                                                index={_index}
                                                className='desc-slicee'
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td>
                                            <div>
                                              <PopoverText
                                                content={
                                                  item.incoterm2?.code
                                                    ? item.incoterm1?.code +
                                                      '-' +
                                                      item.incoterm2?.code
                                                    : item.incoterm1?.code +'-'+ item.incoterm2
                                                }
                                                index={_index}
                                                className='desc-slicee'
                                              />
                                            </div>
                                          </td>
                                        )
                                      ) : (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                incotermId2
                                                  ? incotermIdDesc + '-' + incotermId2
                                                  : incotermIdDesc
                                              }
                                              index={_index}
                                              className='desc-slicee'
                                            />
                                          </div>
                                        </td>
                                      )}
                                    </>
                                  )
                                }

                                <td>
                                  <button
                                    onClick={() => {
                                      setTempDetail(item)
                                      setQuantumSO(item.quantity)
                                      setRute(item.route_desc)
                                      setShowDetail(true)
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title='Detail'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/file-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>

                                  {item?.status === 6 && (
                                    <ActionIcon
                                      className='me-1'
                                      iconPath='/media/icons/duotune/pencil-fill.svg'
                                      onClick={() => {
                                        appDispatch(setOrderItem(item))
                                        setShowModalEditSO(true)
                                      }}
                                    />
                                  )}

                                  {editFlag == true ? (
                                    <button
                                      onClick={() => {
                                        setTempIndex(_index)
                                        setEditId(item.id)
                                        handleLefoverObject(
                                          item.order_sub_detail?.id,
                                          item.quantity
                                        )
                                        setSloc(item.sloc)
                                        setSlocDesc(item.sloc_description)
                                        setTempQuant(item.quantity)
                                        setPlantName(item.plant_desc)
                                        setPlantID(item.plant)
                                        setSloc(item.sloc)
                                        setSlocDesc(item.sloc_description)
                                        setRouteDesc(item.route_desc || '')
                                        setRoute(item.route || '')
                                        setShippingTolerance(item?.shipping_tolerance)
                                        setNote((item.note || item?.order_sub_detail?.notes) || '')
                                        if (item.product_spec == null)
                                          setPspec(item.order_sub_detail.product_spec)
                                        else setPspec(item.product_spec)
                                        setIncoterm(item.incoterm1_id)
                                        setIncoterm2(item.incoterm2)
                                        handleEditPlant(
                                          item.order_sub_detail?.material_number,
                                          item.order_sub_detail,
                                          item.id,
                                          item.quantity
                                        )
                                        appDispatch(setOrderItem(item))
                                      }}
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('ubah')}
                                    >
                                      <KTSVG
                                        // pencil
                                        path='/media/icons/duotune/pencil-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  ) : (
                                    ''
                                  )}
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                    onClick={() => {
                                      setFileBox(item?.order_sub_detail)
                                      setIndex2(_index)
                                      removeFileState()
                                      handleUploadOrderItem(item)
                                      setAttachmentType('so-item')
                                      item?.order_sub_item_id ? ambilAttachment(item.order_sub_item_id, 'order-item') : ambilAttachment(item.id, 'so-item')
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  {regarding == 'PO001' && (
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Jadwal')}
                                      onClick={() => {
                                        setSektorId(item.order_sub_detail.sector_id)
                                        setProvinceName(item.order_sub_detail.province?.region_name)
                                        setCityName(item.order_sub_detail.city?.city_name)
                                        setProductName(item.order_sub_detail.product_name)
                                        formattingTon(item.order_sub_detail.fixed_quantum)
                                        setTipeProduct(item.order_sub_detail.product_type)
                                        setUnitProduct(item.order_sub_detail.unit)
                                        setOrderSubID(
                                          item.order_sub_detail?.order_sub_item_id == null
                                            ? item.order_sub_detail?.id
                                            : item.order_sub_detail?.order_sub_item_id
                                        )
                                        setShowJadwal(true)
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/calendar-check-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  )}

                                  
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Hapus')}
                                      disabled={roleUser == 'admin' ? true : false}
                                      onClick={() => removeSubOrder(_index)}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/trash-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                </td>
                                <td>
                                  <div>{t(item.order_sub_detail?.sector?.name)}</div>
                                </td>
                                <td>
                                  <div>{item.order_sub_detail?.product_type_desc}</div>
                                </td>
                                <td>
                                  <div>
                                    {parseInt(item.order_sub_detail?.material_number) == 0 ? (
                                      <label className='opacity-0'>-</label>
                                    ) : (
                                      item.order_sub_detail?.material_number?.slice(-7)
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div>{item.order_sub_detail?.product_name}</div>
                                </td>
                                <td>
                                  <div>
                                    <PopoverText
                                      content={
                                        item.product_spec || item.order_sub_detail?.product_spec
                                      }
                                      index={_index}
                                      className='spec-slicee'
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {i18next.language === 'en'
                                      ? item.quantity?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.quantity?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.order_sub_detail.product_type == '8105' ? item.order_sub_detail.unit : 'Ton'}
                                  </div>
                                </td>
                                {/* {idSector != 2 ? (
                          <td>
                          {i18next.language === 'en'
                            ? item.order_sub_detail?.shipping_tolerance?.toLocaleString('en', {maximumFractionDigits: 4})
                            : item.order_sub_detail?.shipping_tolerance?.toLocaleString('id', {maximumFractionDigits: 4})}
                        </td>
                        ) : ''} */}
                                <td>
                                  <div>
                                    {(idSector != 3 ? 'Rp ' : 'USD ') +
                                      ((i18next.language === 'en') ?
                                        (item?.price || item?.order_sub_detail?.fixed_price)?.toLocaleString(
                                            'en',
                                            {
                                              maximumFractionDigits: 4,
                                            }
                                          )
                                          : (item?.price || item?.order_sub_detail?.fixed_price)?.toLocaleString(
                                            'id',
                                            {
                                              maximumFractionDigits: 4,
                                            }
                                          ))}
                                    /
                                    {item.order_sub_detail.product_type == '8105'
                                      ? item.order_sub_detail.unit
                                      : idSector != 3
                                      ? 'Ton'
                                      : 'MT'}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {(idSector != 3 ? 'Rp ' : 'USD ') +
                                      (i18next.language === 'en'
                                        ? item.price_before_ppn?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.price_before_ppn?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))}
                                  </div>
                                </td>
                                <td>
                                  <div>{item?.ppn ? item?.ppn : '0'}%</div>
                                </td>
                                <td>
                                  <div>
                                    {(idSector != 3 ? 'Rp ' : 'USD ') +
                                      (i18next.language === 'en'
                                        ? item.price_after_ppn?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.price_after_ppn?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <PopoverText
                                      content={item.plant_desc || '-'}
                                      index={_index}
                                      className='desc-slicee'
                                      placement='bottom'
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {item.route_desc ? (
                                      <>
                                        <PopoverText
                                          content={item.route_desc}
                                          index={_index}
                                          className='desc-slicee'
                                          placement='bottom'
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <label className='opacity-0'>-</label>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                            {addedProduct.map((item, _index) => (
                              <tr key={item?.id ?? _index} className='overflow-auto'>
                                <td>
                                  <div>{item.sales_org_code_desc}</div>
                                </td>
                                <td>
                                  <div>
                                    <PopoverText
                                      content={
                                        item.incoterm1_desc +
                                        (item.incoterm2_id == '' ? '' : '-' + item.incoterm2_id)
                                      }
                                      index={_index}
                                      className='desc-slicee'
                                    />
                                  </div>
                                </td>
                                <td>
                                  <button
                                    onClick={() => {
                                      setTempDetail(item)
                                      setRute(item.route_desc)
                                      setQuantumSO(item.quantity)
                                      setShowDetail(true)
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title='Detail'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/file-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <a
                                    onClick={() => {
                                      setTempIndex(_index)
                                      getroutedata(item.sales_org_code)
                                      setEditId(item.id)
                                      setSloc(item.sloc)
                                      setSlocDesc(item.sloc_description)
                                      setTempQuant(item.quantity)
                                      setPlantName(item.plant_desc)
                                      setPlantID(item.plant)
                                      setSloc(item.sloc)
                                      setSlocDesc(item.sloc_description)
                                      setRouteDesc(item.route_desc || '')
                                      setPspec(item.product_spec)
                                      setPtype(item.product_type)
                                      setPunit(item.unit)
                                      setPtype2(item.product_type_desc)
                                      handleEditPlant(
                                        item.material_number,
                                        item,
                                        item.id,
                                        item.quantity,
                                        'product'
                                      )
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('ubah')}
                                  >
                                    <KTSVG
                                      // pencil
                                      path='/media/icons/duotune/pencil-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </a>
                                  <button
                                    onClick={() => {
                                      setFileBox(item?.order_sub_detail)
                                      setIndex2(_index)
                                      removeFileState()
                                      handleUploadOrderItem(item)
                                      setAttachmentType('so-item')
                                      setAllFiles([])
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('tambah_jadwal')}
                                    onClick={() => {
                                      formattingTon(item.request_quantum)
                                      setProvinceName(item.province_desc)
                                      setCityName(item.city_desc)
                                      setProductName(item.product_name)
                                      setTipeProduct(item.product_type)
                                      setUnitProduct(item.unit)
                                      setIndex2(_index)
                                      handleJadwal(item)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/calendar-check-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                    onClick={() => removeProduct(_index)}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </td>
                                <td>
                                  <div>
                                    {item.sector_id == 1
                                      ? t('Domestik Korperasi')
                                      : item.sector_id == 3
                                      ? t('Export')
                                      : ''}
                                  </div>
                                </td>
                                <td>
                                  <div>{item.product_type_desc}</div>
                                </td>
                                <td>
                                  <div>
                                    {parseInt(item.material_number) == 0
                                      ? ''
                                      : item.material_number?.slice(-7)}
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td>
                                  <div>{item.product_name}</div>
                                </td>
                                <td>
                                  <div>
                                    <PopoverText
                                      content={item?.product_spec}
                                      index={_index}
                                      className='spec-slicee'
                                    />
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {i18next.language === 'en'
                                      ? item.quantity?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.quantity?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.product_type == '8105'
                                      ? item.unit
                                      : item.sector_id != 3
                                      ? 'Ton'
                                      : 'MT'}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {item.sector_id == 1 ? 'Rp ' : 'USD '}
                                    {i18next.language === 'en'
                                      ? item.request_price?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.request_price?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}
                                    /
                                    {item.product_type == '8105'
                                      ? item.unit
                                      : item.sector_id != 3
                                      ? 'Ton'
                                      : 'MT'}
                                  </div>
                                </td>

                                <td>
                                  <div>
                                    {item.sector_id == 1 ? 'Rp ' : 'USD '}
                                    {i18next.language === 'en'
                                      ? (item.quantity * item.request_price).toLocaleString('en')
                                      : (item.quantity * item.request_price).toLocaleString('id')}
                                  </div>
                                </td>
                                <td>
                                  <div>{item.request_price == 0 ? 0 : ppn}%</div>
                                </td>
                                <td>
                                  <div>
                                    {item.sector_id == 1 ? 'Rp ' : 'USD '}
                                    {i18next.language === 'en'
                                      ? (
                                          (ppn / 100) * (item.quantity * item.request_price) +
                                          item.quantity * item.request_price
                                        ).toLocaleString('en', {maximumFractionDigits: 4})
                                      : (
                                          (ppn / 100) * (item.quantity * item.request_price) +
                                          item.quantity * item.request_price
                                        ).toLocaleString('id', {maximumFractionDigits: 4})}
                                  </div>
                                </td>
                                <td>
                                  <div className='fs-6 py-3'>
                                    {item.plant_desc}
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {item.route_desc ? (
                                      <>
                                        <PopoverText
                                          content={item.route_desc}
                                          index={_index}
                                          className='desc-slicee'
                                          placement='bottom'
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <label className='opacity-0'>-</label>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                    {/* End Table Head */}
                  </div>

                  {priceBefore != 0 && (
                    <div className='w-50 mt-5'>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-3'>Total {t('Kuantum')}</p>
                        </Col>
                        <Col md={7}>
                          {totalquant == 0 ? (
                            <Form.Control size='sm' aria-label='Default example' disabled />
                          ) : (
                            <Form.Control
                              aria-label='Default example'
                              key={totalquant + totalQuantumProduct}
                              value={
                                (i18next.language === 'en'
                                  ? (totalquant + totalQuantumProduct)?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : (totalquant + totalQuantumProduct)?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                ' ' +
                                'Ton'
                              }
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                      <Row
                        className='mt-3'
                        hidden={totalPcs == 0 && totalPcsProduct == 0 ? true : false}
                      >
                        <Col md={5}>
                          <p className='fs-4 mt-3'>Total {t('sack')}</p>
                        </Col>
                        <Col md={7}>
                          {totalPcs == 0 && totalPcsProduct == 0 ? (
                            <Form.Control size='sm' aria-label='Default example' disabled />
                          ) : (
                            <Form.Control
                              aria-label='Default example'
                              key={totalPcs + totalPcsProduct}
                              value={
                                (i18next.language === 'en'
                                  ? (totalPcs + totalPcsProduct)?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : (totalPcs + totalPcsProduct)?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) + ' EA'
                              }
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                        </Col>
                        <Col md={7}>
                          {priceBefore == 0 ? (
                            <Form.Control size='sm' aria-label='Default example' disabled />
                          ) : (
                            <Form.Control
                              aria-label='Default example'
                              key={priceBefore + totalPriceProductBefore}
                              value={
                                idSector != 3
                                  ? 'Rp ' +
                                    (i18next.language === 'en'
                                      ? (
                                          Math.round(priceBefore) +
                                          Math.round(totalPriceProductBefore)
                                        )?.toLocaleString('en', {maximumFractionDigits: 4})
                                      : (
                                          Math.round(priceBefore) +
                                          Math.round(totalPriceProductBefore)
                                        )?.toLocaleString('id', {maximumFractionDigits: 4}))
                                  : 'USD ' +
                                    (i18next.language === 'en'
                                      ? (priceBefore + totalPriceProductBefore)?.toLocaleString(
                                          'en',
                                          {
                                            maximumFractionDigits: 4,
                                          }
                                        )
                                      : (priceBefore + totalPriceProductBefore)?.toLocaleString(
                                          'id',
                                          {
                                            maximumFractionDigits: 4,
                                          }
                                        ))
                              }
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}

                  {priceAfter != 0 && (
                    <div className='w-50 mt-3'>
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                        </Col>
                        <Col md={7}>
                          {priceAfter == 0 ? (
                            <Form.Control size='sm' aria-label='Default example' disabled />
                          ) : (
                            <>
                              <Form.Control
                                key={totalafterppn}
                                aria-label='Default example'
                                value={
                                  idSector != 3
                                    ? 'Rp ' +
                                      (i18next.language === 'en'
                                        ? Math.round(totalafterppn)?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : Math.round(totalafterppn)?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))
                                    : 'USD ' +
                                      (i18next.language === 'en'
                                        ? totalafterppn?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : totalafterppn?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))
                                }
                                disabled
                              />
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}

                  <div className='d-flex justify-content-end mt-5'>
                    <Link to={'/management/so'}>
                      <Button className='btn btn-secondary me-2'>
                        {approvalFlag == true ||
                        ((status == 6 || status == 9) &&
                          SOSAPNum != null &&
                          roleUser == 'salesAnper')
                          ? t('cancel')
                          : t('order-kembali')}
                      </Button>
                    </Link>
                    <Button
                      className='btn btn-primary me-2'
                      onClick={() => create2()}
                      disabled={btnLoading}
                    >
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('Save')
                      )}
                    </Button>
                  </div>
                </div>
              </>
        )}

        <ModalAddSO
          fullIncoterm={fullIncoterm} 
          leftOverQuantities={leftoverArray} 
          show={showAddSO} 
          setShow={setShowAddSO} 
          contractItems={contractItems} 
          onSubmit={(new_item: any) => {addNewSoItem(new_item)}}
        />

        <Modal 
          show={show} 
          onHide={() => {
            cleareFormEditSO()
            handleClose()  
           }} 
           backdrop='static' 
           keyboard={false}
           centered 
           size='lg'
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Edit')} Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <SkeletonPageDetail />
            ) : (
              <>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>ID Sub SO</Form.Label> 
                  </Col>
                  <Col md={8}>
                    <Form.Control type='text' value={detailId} disabled className='mb-3' size='sm' />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('Route')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Select
                      key={detailId + fullRoute}
                      placeholder={t('pilih')}
                      className='mb-3'
                      defaultValue={
                        fullRoute[
                          fullRoute.findIndex((item: any) => item.label.match(routeDesc || 'null'))
                        ]
                      }
                      onChange={(e: any) => separator2(e.value, setRoute, setRouteDesc)}
                      options={fullRoute}
                    />
                  </Col>
                </Row>

                {/* <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={
                        detailItem?.incoterm1?.code +
                        (detailItem?.incoterm2_id ? '-' + detailItem?.incoterm2_id : '')
                      }
                      disabled
                      className='mb-3'
                      size='sm'
                    />
                  </Col>
                </Row> */}

                  <Row className='mb-3'>
                    <Col md={4}>
                      <Form.Label className='mt-3'>Incoterm</Form.Label>
                    </Col>
                    <Col md={8}>
                      {/* <Form.Control size='sm' aria-label='Default select example' value={incotermCode} disabled /> */}
                      <ReactSelect
                        placeholder={t('pilih')}
                        defaultValue={fullIncoterm.find((item: any) => {
                          let expl = item.value?.split("~#~")
                          return expl[0] == incoterm
                        })}
                        options={fullIncoterm}
                        onChange={(option: any) => {
                          let expl = option.value.split("~#~")
                          setIncoterm(expl[0])
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={4}>
                      <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                    </Col>
                    <Col md={8}>
                      <Form.Control onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example' defaultValue={incoterm2} />
                    </Col>
                  </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('Plant')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Select
                      key={fullPlant + plantID}
                      placeholder={t('pilih')}
                      defaultValue={
                        fullPlant[
                          fullPlant.findIndex((item: any) => item.label == plantID + '-' + plantName)
                        ]
                      }
                      onChange={(e: any) => separator2(e.value, setPlantID, setPlantName)}
                      options={fullPlant}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label className='mt-2'>{t('storage location')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Select
                      key={fullSloc + plantID + sloc + slocDesc}
                      placeholder={t('pilih')}
                      defaultValue={
                        sloc == null || sloc == 'null'
                          ? ''
                          : fullSloc[
                              fullSloc.findIndex((item: any) => item.label == sloc + '-' + slocDesc)
                            ]
                      }
                      onChange={(e: any) => separator2(e.value, setSloc, setSlocDesc)}
                      options={fullSloc}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sub-order-jenis')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={detailItem?.product_type + '-' + detailItem?.product_type_desc}
                      disabled
                      className='mb-3'
                      size='sm'
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sub-order-produk')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={detailItem?.material_number?.slice(-7) + '-' + detailItem?.product_name}
                      disabled
                      className='mb-3'
                      size='sm'
                    />
                  </Col>
                </Row>


                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sub-order-spek')}</Form.Label>   
                  </Col>
                  <Col md={8}>
                    {idSector == 2 ? (
                      <FieldProductSpec data={pspec} />
                    ) : (
                      <div>
                        <RichText
                          containerClassName='mt-4'
                          content={pspec}
                          onUpdate={({editor}) => {
                            setPspec(editor.getHTML())
                          }}
                        >
                          &nbsp;
                        </RichText>
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {
                        detailItem?.sector_id == 2 ?
                        t('sip-price')
                        : t('contract-price')
                      }
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                    className='mb-3'
                      key={totalbatas}
                      aria-label='Default select example'
                      disabled
                      value={
                        detailItem?.sector_id === 3
                          ? 'USD '
                          : ' Rp ' + 
                        (isNaN(detailItem?.price_contract)
                          ? 0
                          : (i18next.language === 'en'
                              ? parseInt(detailItem?.price_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseInt(detailItem?.price_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) +
                            (detailItem?.product_type == '8105'
                              ? ' /EA'
                              : detailItem?.sector_id === 3
                              ? ' /MT'
                              : ' /Ton'))
                      }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {tipeProduct == '8105'
                        ? t('sisakantong')
                        : t('CREATE_SO.ADD_SO_MODAL.QUANTUM_CONTRACT_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                        aria-label='Default select example'
                        disabled
                        size='sm'
                        value={
                          detailItem ? 
                          `${new Intl.NumberFormat(
                            i18next.language === 'en' ? 'en' : 'id'
                          ).format(Number(detailItem?.quantum_contract))} Ton (+/- ${
                            detailItem?.shipping_tolerance_contract ?? 0
                          }%)` : ''
                        }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('CREATE_SO.ADD_SO_MODAL.KUANTUM_SO_RILIS_LABEL')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={detailItem ? detailItem.so_qty_realized + ' Ton' : ''}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label hidden={totalbatas <= 0 ? true : false}>
                      {detailItem?.product_type == '8105' ? t('sack') : t('quantumsisa')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={totalbatas}
                      aria-label='Default select example'
                      hidden={totalbatas == 0 ? true : false}
                      disabled
                      value={
                        isNaN(totalbatas)
                          ? 0
                          : (i18next.language === 'en'
                              ? totalbatas.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : totalbatas.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) +
                            (detailItem?.product_type == '8105'
                              ? ' EA'
                              : detailItem?.sector_id === 3
                              ? ' MT'
                              : ' Ton')
                      }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label className='mt-3'>
                      {detailItem?.product_type == '8105' ? t('sack') : t('sub-order-kuantum')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup className=''>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        disabled={idSector == 1 ? false : true}
                        defaultValue={quantityEdit}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          setQuantityEdit(value?.replace(/,/g, '.'))
                        }}
                        decimalsLimit={3}
                        placeholder={t('sub-order-kuantum')}
                      />
                      <InputGroup.Text>
                        <span className='px-2'>
                          {detailItem?.product_type == '8105'
                            ? detailItem?.unit
                            : detailItem?.sector_id === 3
                            ? ' MT'
                            : ' Ton'}
                        </span>
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {t('CREATE_SO.ADD_SO_MODAL.TOLERANCE_QUANTUM_SO_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                          className='form-control form-control-sm'
                          decimalSeparator={i18next.language === 'en' ? '.' : ','}
                          groupSeparator={i18next.language === 'en' ? ',' : '.'}
                          decimalsLimit={3}
                          defaultValue={shipping_tolerance}
                          onValueChange={(v: any) => {
                              setShippingTolerance(parseFloat(v?.replace(/,/g, '.')))
                          }}
                      />
                      <InputGroup.Text
                        id='basic-addon2'
                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                      >
                        <span style={{padding: '0 6.5px'}}>%</span>
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-catatan')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      placeholder={t('sub-order-catatan')}
                      type='text'
                      as='textarea'
                      value={note || detailItem?.notes}
                      onChange={(e: any) => {
                        setNote(e?.target?.value)
                      }}
                    />
                  </Col>
                </Row>

                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    className='btn btn-primary'
                    onClick={() => editPlantSO()}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('Save')
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={showEdit2}
          onHide={() => {
            cleareFormEditSO()
            setShowEdit2(false)
          }}
          backdrop='static'
          keyboard={false}
          centered
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Edit')} Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <div className='d-flex justify-content-center'>
                <span className=''>Loading...</span>
              </div>
            ) : (
              <>
                <Form.Label>{t('Route')}</Form.Label>
                <Select
                  key={detailId + fullRoute}
                  placeholder={t('pilih')}
                  className='mb-3'
                  defaultValue={
                    fullRoute[
                      fullRoute.findIndex((item: any) => item.label.match(routeDesc || 'null'))
                    ]
                  }
                  onChange={(e: any) => separator2(e.value, setRoute, setRouteDesc)}
                  options={fullRoute}
                />
                {/* <Form.Label>Incoterm</Form.Label>
                <Form.Control
                  type='text'
                  value={
                    detailItem?.incoterm1_desc +
                    (detailItem?.incoterm2_id ? '-' + detailItem?.incoterm2_id : '')
                  }
                  disabled
                  className='mb-3'
                  size='sm'
                /> */}

                <Form.Label className='mt-3'>Incoterm</Form.Label>
                <ReactSelect
                  placeholder={t('pilih')}
                  defaultValue={fullIncoterm.find((item: any) => {
                    let expl = item.value?.split("~#~")
                    return expl[0] == detailItem?.incoterm1_id
                  })}
                  options={fullIncoterm}
                  onChange={(option: any) => {
                    let expl = option.value.split("~#~")
                    setIncoterm(expl[0])
                  }}
                />
                <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                <Form.Control onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example' defaultValue={detailItem?.incoterm2_id} />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                  <Form.Label>{t('Plant')}</Form.Label>
                  <Select
                    key={fullPlant + plantID}
                    placeholder={t('pilih')}
                    defaultValue={
                      fullPlant[
                        fullPlant.findIndex((item: any) => item.label == plantID + '-' + plantName)
                      ]
                    }
                    onChange={(e: any) => separator2(e.value, setPlantID, setPlantName)}
                    options={fullPlant}
                  />
                  <Form.Label className='mt-2'>{t('storage location')}</Form.Label>
                  <Select
                    key={fullSloc + plantID + sloc + slocDesc}
                    placeholder={t('pilih')}
                    defaultValue={
                      sloc == null || sloc == 'null'
                        ? ''
                        : fullSloc[
                            fullSloc.findIndex((item: any) => item.label == sloc + '-' + slocDesc)
                          ]
                    }
                    onChange={(e: any) => separator2(e.value, setSloc, setSlocDesc)}
                    options={fullSloc}
                  />
                </Form.Group>
                <Form.Label>{t('sub-order-jenis')}</Form.Label>
                <Form.Select
                  size='sm'
                  aria-label='Default select example'
                  onChange={(e: any) => {
                    setFullProductName([])
                    separator2(e.target.value, setPtype, setPtype2)
                  }}
                >
                  <option hidden value=','>
                    {t('Pilih-productType')}
                  </option>
                  {fullProductType.map((item: any) => {
                    return (
                      <>
                        {detailItem.product_type_desc == item.material_group_desc ? (
                          <option
                            selected
                            value={item.material_group + '~#~' + item.material_group_desc}
                          >
                            {item.material_group}-{t(item.material_group_desc)}
                          </option>
                        ) : (
                          <option value={item.material_group + '~#~' + item.material_group_desc}>
                            {item.material_group}-{t(item.material_group_desc)}
                          </option>
                        )}
                      </>
                    )
                  })}
                </Form.Select>
                <Form.Label>{t('sub-order-produk')}</Form.Label>
                <Select
                  id='produk'
                  placeholder={t('pilih')}
                  key={ptype + fullProductName}
                  defaultValue={
                    fullProductName[
                      fullProductName.findIndex(
                        (item: any) => item.truevalue == parseInt(detailItem.material_number)
                      )
                    ]
                  }
                  onChange={(e: any) => {
                    // setQuantum(0)
                    // fieldClearer(1)
                    // setSubprice(0)
                    setPunit(e?.unit)
                    separator3(e?.value, setPnumber, setPname)
                  }}
                  options={fullProductName}
                />
                {parseInt(pnumber) == 0 && (
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6'>
                        Custom Product Name<span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        placeholder=' Custom Product Name'
                        size='sm'
                        aria-label='Default select example'
                        type='text'
                        id='custom'
                        onChange={(e: any) => setPname(e.target.value)}
                      />
                    </Col>
                  </Row>
                )}
                <Form.Label>{t('sub-order-spek')}</Form.Label>
                <div>
                  <RichText
                    containerClassName='mt-4'
                    content={pspec}
                    onUpdate={({editor}) => {
                      setPspec(editor.getHTML())
                    }}
                  >
                    &nbsp;
                  </RichText>
                </div>

                <Form.Label>{ptype == '8105' ? t('sack') : t('sub-order-kuantum')}</Form.Label>
                <InputGroup className=''>
                  <CurrencyInput
                    className='form-control form-control-sm'
                    disabled={idSector == 1 ? false : true}
                    defaultValue={quantityEdit}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setQuantityEdit(value?.replace(/,/g, '.'))
                    }}
                    decimalsLimit={3}
                    placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                  />
                  <InputGroup.Text>
                    <span className='px-2'>
                      {ptype == '8105' ? punit : detailItem?.sector_id === 3 ? ' MT' : ' Ton'}
                    </span>
                  </InputGroup.Text>
                </InputGroup>
                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    className='btn btn-primary'
                    onClick={() => editSelectedDetailProduct()}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('Save')
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          size='lg'
          show={showUpload}
          onHide={() => {
            setShowUpload(false)
            setIsPrivate(false)
            setTempRole([])
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {attachmentType == 'so-item' ? (fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')) : <span>{t('File Box')}</span>}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!downloadOnly ? (
              <>
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          <InputFile
                            setFileName={(_: string) => {}}
                            setFiles={setFiles}
                            isBase64={false}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            placeholder={t('order-keterangan')}
                            id='uploadketerangan'
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser == 'null' || roleUser == null ? true : false}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      <Button
                        variant='primary'
                        className='w-100'
                        onClick={() => handleUpload()}
                        disabled={btnLoading}
                      >
                        {btnLoading ? (
                          <Spinner animation='border' variant='light' size='sm' />
                        ) : (
                          t('order-kirim')
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            {allFiles.length < 1 || allFiles.length == undefined ? (
              <></>
            ) : (
              <>
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFiles.map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                handleDownloadAttachment(
                                  data.file_path
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(hakAkses?.attachment_delete ||
                              CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={showJadwal}
          onHide={() => setShowJadwal(false)}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektorId != '3' ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={orderSubID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
          </Modal.Body>
        </Modal>

        <Modal
          show={showEdit}
          onHide={handleCloseEdit}
          backdrop='static'
          size='lg'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('ubah')} Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingModal ? (
              <div className='d-flex justify-content-center'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <Form.Group className='mb-3' controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-kuantum')}</Form.Label>
                  <CurrencyInput
                    id='jadwalton'
                    className='form-control form-control-sm'
                    placeholder={t('sub-order-kuantum')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    decimalsLimit={3}
                    defaultValue={quantityEdit}
                    onValueChange={(value: any) => {
                      setQuantityEdit(value?.replace(/,/g, '.'))
                    }}
                  />
                </Form.Group>
                <Form.Group className='mb-5' controlId='formBasicEmail'>
                  <Form.Label>{t('Price')}</Form.Label>
                  <InputGroup size='sm'>
                    {idSector != 3 ? (
                      <InputGroup.Text>
                        <span className='px-2'>USD</span>
                      </InputGroup.Text>
                    ) : (
                      <InputGroup.Text>
                        <span className='px-1'>Rp</span>
                      </InputGroup.Text>
                    )}
                    <CurrencyInput
                      id='jadwalton'
                      className='form-control form-control-sm'
                      placeholder={t('Price')}
                      decimalSeparator={language === 'en' ? '.' : ','}
                      groupSeparator={language === 'en' ? ',' : '.'}
                      decimalsLimit={idSector != 3 ? -1 : 2}
                      defaultValue={priceEdit}
                      onValueChange={(value: any) => {
                        setPriceEdit(value?.replace(/,/g, '.'))
                      }}
                    />
                  </InputGroup>
                </Form.Group>
                <div className='d-flex justify-content-end'>
                  <Button className='btn btn-primary' onClick={submitEdit}>
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('Save')
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={showAddProduct}
          onHide={() => setShowAddProduct(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('tambah-produk')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {idSector == 3 && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={salesorgname}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <ReactSelect
                          placeholder={t('pilih')}
                          defaultValue={fullIncoterm.find((item: any) => {
                            let expl = item.value?.split("~#~")
                            return expl[0] == incotermId
                          })}
                          options={fullIncoterm}
                          onChange={(option: any) => {
                            let expl = option.value.split("~#~")
                            setIncoterm(expl[0])
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            fieldClearer('province')
                            setFullCity2([])
                            separator2(e?.value, setProvinceProduct, setProvinceDesc)
                          }}
                          options={fullProvince2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          id='jenis'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            fieldClearer('tipe')
                            separator2(e.target.value, setPtype, setPtype2)
                          }}
                        >
                          <option hidden value=','>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any, index: number) => {
                            return (
                              <option
                                key={index}
                                value={item.material_group + '~#~' + item.material_group_desc}
                              >
                                {t(item.material_group_desc)}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            {ptype == '8105' ? punit : 'MT'}
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup>
                          <Form.Control
                            key={pname + ptype}
                            placeholder={ptype == '8105' ? '' : t('Shipping Tolerance')}
                            size='sm'
                            type='number'
                            disabled={ptype == '8105' ? true : false}
                            onChange={(e: any) => setShipping(parseInt(e.target.value))}
                            id='shipping'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            style={{paddingTop: '1px', paddingBottom: '1px'}}
                          >
                            <span className='px-1'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment1')}
                          size='sm'
                          value={pay1Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger' hidden={ptype == '8105' ? true : false}>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          type='text'
                          id='enduser'
                          placeholder={t('End Customer')}
                          // defaultValue={tempData.end_user}
                          onChange={(e: any) => {
                            setEnduser(e.target.value)
                            setEnduserDesc(e.target.value)
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={t('Export')}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            // setIncotermId2(e.target?.value)
                            // setIncotermId2Desc(e.target?.value)
                            setIncoterm2(e.target?.value)
                          }}
                          defaultValue={incotermId2Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          placeholder={t('pilih')}
                          key={provinceProduct}
                          onChange={(e: any) => {
                            separator2(e?.value, setCityProduct, setCityDesc)
                          }}
                          options={fullCity2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          placeholder={t('pilih')}
                          key={ptype + fullProductName}
                          defaultValue={
                            fullProductName[
                              fullProductName.findIndex(
                                (item: any) => item.truevalue == parseInt(pnumber)
                              )
                            ]
                          }
                          onChange={(e: any) => {
                            // fieldClearer(1)
                            setPunit(e?.unit)
                            separator3(e?.value, setPnumber, setPname)
                          }}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-2'>
                      <Col sm={4}>
                        <p className='fs-6'>
                          {t('sub-order-hargaP')}/{ptype == '8105' ? punit : 'MT'}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-2'>USD</span>
                          </InputGroup.Text>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='hargap'
                            // key={pname}
                            disabled={ptype == '8105' ? true : false}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setSubprice(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={2}
                            placeholder={t('sub-order-hargaP')}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspecProduct(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment2')}
                          size='sm'
                          value={pay2Desc}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {idSector == 1 && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={salesorgname}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <ReactSelect
                          placeholder={t('pilih')}
                          value={fullIncoterm.find((item: any) => {
                            let expl = item.value?.split("~#~")
                            return expl[0] == incotermId
                          })}
                          options={fullIncoterm}
                          onChange={(option: any) => {
                            let expl = option.value?.split("~#~")
                            setIncoterm(expl[0])
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            fieldClearer('province')
                            setFullCity2([])
                            separator2(e?.value, setProvinceProduct, setProvinceDesc)
                          }}
                          options={fullProvince2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          id='jenis'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            fieldClearer('tipe')
                            separator2(e.target.value, setPtype, setPtype2)
                          }}
                        >
                          <option hidden value=','>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any, index: number) => {
                            return (
                              <option
                                key={index}
                                value={item.material_group + '~#~' + item.material_group_desc}
                              >
                                {t(item.material_group_desc)}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            {ptype == '8105' ? punit : 'Ton'}
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup>
                          <Form.Control
                            key={pname + ptype}
                            placeholder={ptype == '8105' ? '' : t('Shipping Tolerance')}
                            size='sm'
                            type='number'
                            disabled={ptype == '8105' ? true : false}
                            onChange={(e: any) => setShipping(parseInt(e.target.value))}
                            id='shipping'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            style={{paddingTop: '1px', paddingBottom: '1px'}}
                          >
                            <span className='px-1'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment1')}
                          size='sm'
                          value={pay1Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Select
                            id='segment'
                            onChange={(e: any) => separator2(e.target.value, setSegment, setSegmentDesc)}
                            aria-label='Default select example'
                            size='sm'
                          >
                            <option hidden value=','>
                              {t('Pilih-segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + '~#~' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                    <Row className=''>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger' hidden={ptype == '8105' ? true : false}>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        {isNoEnduser ? (
                          <>
                            <Form.Control
                              size='sm'
                              type='text'
                              id='enduser'
                              placeholder={t('End Customer')}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          </>
                        ) : (
                          <MultiSelect
                            options={fullEndUser?.map((item: any) => {
                              return {label: t(item.name), value: item.name}
                            })}
                            value={arrayEnduser}
                            onChange={(e: any) => setEnduserArray(e)}
                            labelledBy='Select'
                          />
                          // <Form.Select
                          //   size='sm'
                          //   aria-label='Default select example'
                          //   id='enduser2'
                          //   onChange={(e: any) => {
                          //     separateValue4(
                          //       e.target.value,
                          //       setEnduser,
                          //       setEnduserDesc
                          //     )
                          //   }}
                          // >
                          //   <option selected value={0 + '~#~'}>
                          //     {t('pilih')} {t('End Customer')}
                          //   </option>
                          //   {fullEndUser.map((item: any) => {
                          //     return (
                          //       <option
                          //         value={item.end_user_code + '~#~' + item.name}
                          //       >
                          //         {t(item.name)}
                          //       </option>
                          //     )
                          //   })}
                          // </Form.Select>
                        )}
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col sm={4}></Col>
                      <Col sm={8} className='d-flex align-items-center'>
                        <Form.Check
                          onClick={() => {
                            setIsNoEnduser(!isNoEnduser)
                          }}
                          defaultChecked={isNoEnduser}
                          name='noenduser'
                          disabled={disableCKBOX}
                          id='noenduser'
                          className='mt-5 mb-2'
                          type='checkbox'
                        />
                        {i18next.language == 'en' ? (
                          <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                        ) : (
                          <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={t('Domestik Korperasi')}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            // setIncotermId2(e.target?.value)
                            // setIncotermId2Desc(e.target?.value)
                            setIncoterm2(e.target?.value)
                          }}
                          defaultValue={incotermId2Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-kota')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          placeholder={t('pilih')}
                          key={provinceProduct}
                          onChange={(e: any) => {
                            separator2(e?.value, setCityProduct, setCityDesc)
                          }}
                          options={fullCity2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          placeholder={t('pilih')}
                          key={ptype + fullProductName}
                          defaultValue={
                            fullProductName[
                              fullProductName.findIndex(
                                (item: any) => item.truevalue == parseInt(pnumber)
                              )
                            ]
                          }
                          onChange={(e: any) => {
                            // fieldClearer(1)
                            setPunit(e?.unit)
                            separator3(e?.value, setPnumber, setPname)
                          }}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-2'>
                      <Col sm={4}>
                        <p className='fs-6'>
                          {t('sub-order-hargaP')}/{ptype == '8105' ? punit : 'Ton'}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-1'>Rp</span>
                          </InputGroup.Text>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='hargap'
                            // key={pname}
                            defaultValue={subprice}
                            disabled={ptype == '8105' ? true : false}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setSubprice(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={-1}
                            placeholder={t('sub-order-hargaP')}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-4'>{t('termasuk-ppn')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='ppn'
                          disabled={ptype == '8105' ? true : false}
                          className='mt-4 mb-2'
                          type='checkbox'
                          id='ckbox-ppn'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment2')}
                          size='sm'
                          value={pay2Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspecProduct(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Select
                            id='segment'
                            onChange={(e: any) => separator2(e.target.value, setSegment, setSegmentDesc)}
                            aria-label='Default select example'
                            size='sm'
                          >
                            <option hidden value=','>
                              {t('Pilih-segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + '~#~' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}
            <div className='d-flex justify-content-end mt-5'>
              <Button variant='primary' onClick={() => insertAddOrder()}>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                {t('order-kirim')}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showJadwal2}
          onHide={() => setShowJadwal2(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {idSector != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <div className='table-responsive bdr mt-1'>
              <table className='table-border w-100'>
                <thead>
                  <tr className='d-flex'>
                    {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                    <th style={{width: '165.5px'}} className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <div>
                    <tr className='d-flex'>
                      <td style={{width: '165.5px'}} className='text-center'>
                        <p className='mt-3'>{taking + 1}</p>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          id='jadwaltanggal'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                        >
                          <option selected value={0} disabled hidden>
                            {t('Pilih-Tanggal')}
                          </option>
                          {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Control
                          aria-label='Default select example'
                          id='jadwalminggu'
                          placeholder={t('order-minggu')}
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          defaultValue={
                            tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)
                          }
                        />
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          id='jadwalbulan'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                        >
                          <option selected disabled>
                            {t('Pilih-Month')}
                          </option>
                          <option value='1'>{t('Januari')}</option>
                          <option value='2'>{t('Februari')}</option>
                          <option value='3'>{t('Maret')}</option>
                          <option value='4'>{t('April')}</option>
                          <option value='5'>{t('Mei')}</option>
                          <option value='6'>{t('Juni')}</option>
                          <option value='7'>{t('Juli')}</option>
                          <option value='8'>{t('Agustus')}</option>
                          <option value='9'>{t('September')}</option>
                          <option value='10'>{t('Oktober')}</option>
                          <option value='11'>{t('November')}</option>
                          <option value='12'>{t('Desember')}</option>
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          id='jadwaltahun'
                          onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                        >
                          <option selected disabled>
                            {t('Pilih-Year')}
                          </option>
                          {listYear.map((data: string, index: number) => {
                            return (
                              <option key={data ?? index} value={data}>
                                {data}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <CurrencyInput
                          id='jadwalton'
                          className='form-control form-control-sm'
                          placeholder={tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                          key={tempTahun}
                          style={{width: '90%'}}
                          decimalSeparator={language === 'en' ? '.' : ','}
                          groupSeparator={language === 'en' ? ',' : '.'}
                          onValueChange={(value: any) => {
                            setTempTon(parseFloat(value?.replace(/,/g, '.')))
                          }}
                          decimalsLimit={3}
                        />
                      </td>
                    </tr>
                  </div>
                </tbody>
                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    variant='primary'
                    onClick={() => {
                      sendJadwal()
                    }}
                  >
                    {t('order-kirim')}
                  </Button>
                </div>
              </table>
            </div>
            <div
              className='table-responsive bdr mt-8'
              hidden={allJadwal?.length < 1 || allJadwal?.length == undefined ? true : false}
            >
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className='fw-bold'>
                    <th className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th className='text-center'>
                      {tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                    </th>
                    <th className='text-center'>
                      {t('order-aksi')}
                    </th>
                  </tr>
                </thead>
                {allJadwal?.map((data, _index) => (
                  <tbody key={data?.id ?? _index}>
                    <tr className=''>
                      <td className='text-center'>
                        <label className='mt-3'>{_index + 1}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{data.date}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>
                          {t('Week')}
                          {Math.ceil(data.date / 7)}
                        </label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{data.year}</label>
                      </td>
                      <td className='text-center'>
                        {editedIndex == _index ? (
                          <CurrencyInput
                            id='ton'
                            placeholder={tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                            className='form-control form-control-sm'
                            defaultValue={data.tonnage}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        ) : (
                          <label className='mt-3'>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              (tipeProduct != '8105' ? 'Ton' : unitProduct)}
                          </label>
                        )}
                      </td>
                      <td className='text-center'>
                        {editedIndex == _index ? (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Approve')}
                            onClick={() => rubahSchedule(_index, tempTon, data.tonnage)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/check-square.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        ) : (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('ubah')}
                            onClick={() => {
                              setEditedIndex(_index)
                              setTempTon(data.tonnage)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/pencil-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}

                        <button
                          onClick={() => hapusSchedule(_index)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size='lg'
          show={showUpload3}
          onHide={() => {
            setShowUpload3(false)
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <InputFile
                        setFileName={setNamaFile}
                        setFiles={setFiles3}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        id='uploadketerangan2'
                        placeholder={t('order-keterangan')}
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                <table
                  className='mb-3'
                  hidden={roleUser == 'null' || roleUser == null ? true : false}
                >
                  <tr>
                    <td>
                      <h6 className='me-11'>{t('Private')}</h6>
                    </td>
                    <td className='w-75 d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='isPrivate'
                        type='checkbox'
                        className='mt-5 mb-2'
                        onClick={() => {
                          setIsPrivate(!isPrivate)
                          setTempRole([])
                        }}
                        id='isPrivate'
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isPrivate ? false : true}>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('Akses Role')}</h6>
                    </td>
                    <td className='w-75' style={{maxWidth: '274px'}}>
                      <MultiSelect
                        key={isPrivate.toString()}
                        options={fullRole?.map((item: any) => {
                          return {label: item.label, value: item.value}
                        })}
                        value={tempRole}
                        onChange={(e: any) => setTempRole(e)}
                        labelledBy='Select'
                      />
                    </td>
                  </tr>
                </table>
                <div className='d-flex justify-content-end'>
                  <Button variant='primary' className='w-100' onClick={() => handleUpload3()}>
                    {t('order-kirim')}
                  </Button>
                </div>
              </Col>
              <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {orderItemFiles
                    .slice(0)
                    .reverse()
                    .map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(getCurrentFormattedDate())}</label>
                          </td>
                          <td className='text-center'>
                            <label>{localStorage.getItem('username')}</label>
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleNameFromState(data.roles)}
                                  index={_index}
                                  className=''
                                  style={{
                                    'overflow': 'hidden',
                                    "white-space": 'nowrap',
                                    "text-overflow": 'ellipsis',
                                    "max-width": '100px',
                                    "font-size": '13px',
                                    "font-weight": '400',
                                    "margin": '0 auto'
                                  }}
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() => handleDownloadBase64(data.file_r)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              onClick={() =>
                                handleDeleteUploadHeader(
                                  orderItemFiles.length - 1 - _index,
                                  orderItemFiles,
                                  setOrderItemsFiles,
                                  'order-item',
                                  tempData,
                                  setTempData
                                )
                              }
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  {allFiles.map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{orderItemFiles.length + _index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                handleDownloadAttachment(
                                  data.file_path
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(hakAkses?.attachment_delete ||
                              CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={showDetail}
          onHide={() => {
            setShowDetail(false)
            setRute('')
          }}
          centered
          scrollable
          backdrop='static'
          size={'xl'}
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={incotermIdDesc} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row
                  className='mb-4'
                  hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
                >
                  <Col sm={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      type='text'
                      size='sm'
                      value={tempDetail?.order_sub_detail?.province?.region_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Plant')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.plant_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (i18next.language === 'en'
                          ? quantumSO.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : quantumSO.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })) + (tempDetail?.order_sub_detail?.sector_id === 3 ? ' MT' : ' Ton')
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      // placeholder={t('Shipping Tolerance')}
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        tempDetail?.shipping_tolerance == 0
                          ? ''
                          : tempDetail?.shipping_tolerance + '%'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.payment_type_1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.payment_note}
                      type='text'
                      as='textarea'
                      style={{height: '40px'}}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('End Customer')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.end_user_multiple
                          ? handleShowValue(tempDetail?.order_sub_detail?.end_user)
                          : tempDetail?.order_sub_detail?.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.sector_id == 3
                          ? t('Export')
                          : tempDetail?.order_sub_detail?.sector_id == 2
                          ? t('Domestik Retail')
                          : t('Domestic Korporasi')
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {tempDetail?.order_sub_detail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          tempDetail?.order_sub_detail?.incoterm2_id == null ||
                          tempDetail?.order_sub_detail?.incoterm2_id == '0'
                            ? ''
                            : tempDetail?.order_sub_detail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={tempDetail?.order_sub_detail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row
                  className='mb-4'
                  hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
                >
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={tempDetail?.order_sub_detail?.city?.city_name}
                      size='sm'
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.product_name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Route')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={rute} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='fs-6 mt-3'>
                      {t('Harga Pengajuan')}/
                      {tempDetail?.order_sub_detail?.product_type == '8105' ? tempDetail?.order_sub_detail?.unit : 'Ton'}
                    </p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.product_type == '8105'
                          ? ''
                          : i18next.language === 'en'
                          ? (tempDetail?.order_sub_detail?.sector_id == 3 ? 'USD ' : 'Rp ') +
                            parseFloat(tempDetail?.order_sub_detail?.fixed_price).toLocaleString(
                              'en',
                              {
                                maximumFractionDigits: 4,
                              }
                            )
                          : (tempDetail?.order_sub_detail?.sector_id == 3 ? 'USD ' : 'Rp ') +
                            parseFloat(tempDetail?.order_sub_detail?.fixed_price).toLocaleString(
                              'id',
                              {
                                maximumFractionDigits: 4,
                              }
                            )
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <FieldProductSpec
                      data={tempDetail.product_spec || tempDetail?.order_sub_detail?.product_spec}
                      type='editor'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row
                  className='mb-4'
                  hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
                >
                  <Col md={4}>
                    <p className='fs-6 mt-3'>{t('segment')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(tempDetail?.order_sub_detail?.segment_name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.notes}
                      type='text'
                      as='textarea'
                      style={{height: '40px'}}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>

      <ModalEditSO
        show={showModalEditSO}
        onHide={() => setShowModalEditSO(false)}
        onSubmit={async () => await getSODetail()}
      />
    </>
  )
}

export {SOReviseNew}
